import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-header-card"
}
const _hoisted_2 = { class: "order-header-top" }
const _hoisted_3 = { class: "order-header-main" }
const _hoisted_4 = { class: "order-header-texts" }
const _hoisted_5 = { class: "order-cod" }
const _hoisted_6 = {
  key: 0,
  class: "po-chip"
}
const _hoisted_7 = {
  key: 1,
  class: "facturat-chip"
}
const _hoisted_8 = {
  key: 2,
  class: "dropship-chip",
  title: "Furnizorul livrează direct la client, fără să treacă prin gestiunea proprie"
}
const _hoisted_9 = { class: "header-actions" }
const _hoisted_10 = { class: "order-meta" }
const _hoisted_11 = { class: "meta-content" }
const _hoisted_12 = { class: "meta-value meta-value--partener" }
const _hoisted_13 = {
  key: 0,
  class: "meta-sub"
}
const _hoisted_14 = { class: "meta-item" }
const _hoisted_15 = { class: "meta-content" }
const _hoisted_16 = { class: "meta-value" }
const _hoisted_17 = { class: "meta-item" }
const _hoisted_18 = { class: "meta-content" }
const _hoisted_19 = { class: "meta-value" }
const _hoisted_20 = { class: "meta-item" }
const _hoisted_21 = { class: "meta-content" }
const _hoisted_22 = { class: "meta-value" }
const _hoisted_23 = { class: "meta-content" }
const _hoisted_24 = { class: "meta-value meta-value--obs" }
const _hoisted_25 = { class: "meta-item" }
const _hoisted_26 = { class: "meta-content" }
const _hoisted_27 = { class: "meta-value" }
const _hoisted_28 = { class: "meta-summary-zone" }
const _hoisted_29 = { class: "meta-cursuri-box" }
const _hoisted_30 = { class: "cursuri-rows" }
const _hoisted_31 = {
  key: 0,
  class: "curs-row"
}
const _hoisted_32 = { class: "curs-valoare" }
const _hoisted_33 = {
  key: 1,
  class: "curs-row"
}
const _hoisted_34 = { class: "curs-valoare" }
const _hoisted_35 = { class: "meta-totals-box" }
const _hoisted_36 = { class: "totals-row" }
const _hoisted_37 = { class: "totals-value-secondary" }
const _hoisted_38 = { class: "totals-row" }
const _hoisted_39 = { class: "totals-value-main" }
const _hoisted_40 = {
  key: 1,
  class: "docs-tabs"
}
const _hoisted_41 = { class: "docs-tab-bar" }
const _hoisted_42 = { class: "tab-badge" }
const _hoisted_43 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_44 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_45 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_46 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_47 = { class: "tab-badge" }
const _hoisted_48 = { class: "docs-tab-actions" }
const _hoisted_49 = {
  key: 0,
  class: "docs-tab-panel"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 0,
  class: "doc-anulat-chip"
}
const _hoisted_53 = { key: 2 }
const _hoisted_54 = {
  key: 0,
  class: "doc-anulat-chip"
}
const _hoisted_55 = { style: {"display":"flex","gap":"2px"} }
const _hoisted_56 = { key: 3 }
const _hoisted_57 = {
  key: 0,
  class: "doc-anulat-chip"
}
const _hoisted_58 = {
  key: 1,
  class: "doc-stornat-chip"
}
const _hoisted_59 = { style: {"display":"flex","gap":"2px"} }
const _hoisted_60 = { key: 4 }
const _hoisted_61 = { style: {"display":"flex","gap":"2px"} }
const _hoisted_62 = { key: 5 }
const _hoisted_63 = { class: "total-cell" }
const _hoisted_64 = {
  key: 2,
  class: "editing-banner"
}
const _hoisted_65 = {
  key: 3,
  class: "loading-placeholder"
}
const _hoisted_66 = { class: "rezervare-cell" }
const _hoisted_67 = {
  key: 0,
  class: "rezervare-text rezervare-none"
}
const _hoisted_68 = ["title", "onClick"]
const _hoisted_69 = { style: {"color":"#94a3b8","font-size":"11px"} }
const _hoisted_70 = { class: "cell-val-fara-disc" }
const _hoisted_71 = { class: "cell-val-cu-disc" }
const _hoisted_72 = { class: "total-cell" }
const _hoisted_73 = {
  key: 0,
  class: "discount-badge"
}
const _hoisted_74 = {
  key: 1,
  class: "no-discount"
}
const _hoisted_75 = { class: "ehp-wrapper" }
const _hoisted_76 = { class: "ehp-header" }
const _hoisted_77 = { class: "rezervare-popup-body" }
const _hoisted_78 = { class: "rezervare-produs-nume" }
const _hoisted_79 = { class: "rezervare-field" }
const _hoisted_80 = { class: "edit-value" }
const _hoisted_81 = { class: "rezervare-field" }
const _hoisted_82 = { class: "edit-label" }
const _hoisted_83 = { class: "ehp-wrapper" }
const _hoisted_84 = { class: "ehp-header" }
const _hoisted_85 = { class: "ehp-header-main" }
const _hoisted_86 = { class: "ehp-texts" }
const _hoisted_87 = { class: "ehp-subtitle" }
const _hoisted_88 = { class: "genereaza-doc-body" }
const _hoisted_89 = { class: "edit-field" }
const _hoisted_90 = { class: "edit-field" }
const _hoisted_91 = { class: "edit-field edit-field--wide" }
const _hoisted_92 = { class: "motiv-popup-body" }
const _hoisted_93 = { class: "ehp-wrapper" }
const _hoisted_94 = { class: "ehp-header" }
const _hoisted_95 = { class: "ehp-header-main" }
const _hoisted_96 = { class: "ehp-texts" }
const _hoisted_97 = { class: "ehp-subtitle" }
const _hoisted_98 = { class: "ehp-body" }
const _hoisted_99 = { class: "form-group-card" }
const _hoisted_100 = { class: "form-group-content" }
const _hoisted_101 = { class: "fg g2" }
const _hoisted_102 = { class: "field" }
const _hoisted_103 = { class: "field" }
const _hoisted_104 = { class: "form-group-card" }
const _hoisted_105 = { class: "form-group-content" }
const _hoisted_106 = { class: "fg g3" }
const _hoisted_107 = { class: "field" }
const _hoisted_108 = { class: "field" }
const _hoisted_109 = { class: "field" }
const _hoisted_110 = { class: "field" }
const _hoisted_111 = { class: "field span2" }
const _hoisted_112 = {
  key: 0,
  class: "field span3 field-switch"
}
const _hoisted_113 = { class: "field span3" }
const _hoisted_114 = { class: "rapida-popup" }
const _hoisted_115 = { class: "ehp-header" }
const _hoisted_116 = { class: "rapida-coduri-section" }
const _hoisted_117 = {
  key: 0,
  class: "rapida-status"
}
const _hoisted_118 = { class: "rapida-results-section" }
const _hoisted_119 = { class: "rapida-results-caption" }
const _hoisted_120 = {
  key: 0,
  class: "rapida-badge-ok"
}
const _hoisted_121 = {
  key: 1,
  class: "rapida-badge-err"
}
const _hoisted_122 = { class: "rapida-table-scroll" }
const _hoisted_123 = { class: "rapida-table" }
const _hoisted_124 = { class: "rapida-status-cell" }
const _hoisted_125 = { class: "rapida-cod-cell" }
const _hoisted_126 = { class: "rapida-den-cell" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = {
  key: 1,
  class: "rapida-negasit"
}
const _hoisted_129 = { class: "rapida-input-cell" }
const _hoisted_130 = { class: "rapida-input-cell" }
const _hoisted_131 = { class: "rapida-input-cell" }
const _hoisted_132 = { class: "rapida-input-cell" }
const _hoisted_133 = {
  key: 1,
  class: "rapida-empty-state"
}
const _hoisted_134 = { class: "ehp-wrapper" }
const _hoisted_135 = { class: "ehp-header" }
const _hoisted_136 = { class: "ehp-header-main" }
const _hoisted_137 = { class: "ehp-texts" }
const _hoisted_138 = { class: "ehp-subtitle" }
const _hoisted_139 = { style: {"padding":"12px","flex":"1","min-height":"0"} }
const _hoisted_140 = { class: "ehp-wrapper" }
const _hoisted_141 = { class: "ehp-header" }
const _hoisted_142 = { class: "ehp-header-main" }
const _hoisted_143 = { class: "ehp-texts" }
const _hoisted_144 = { class: "ehp-subtitle" }
const _hoisted_145 = { style: {"padding":"12px 16px","display":"flex","gap":"12px","flex-shrink":"0"} }
const _hoisted_146 = {
  class: "aviz-field",
  style: {"flex":"0 0 160px"}
}
const _hoisted_147 = {
  class: "aviz-field",
  style: {"flex":"1"}
}
const _hoisted_148 = {
  class: "aviz-field",
  style: {"flex":"1"}
}
const _hoisted_149 = { style: {"flex":"1","min-height":"0","padding":"0 16px 8px"} }
const _hoisted_150 = { class: "ehp-wrapper" }
const _hoisted_151 = { class: "ehp-header" }
const _hoisted_152 = { class: "ehp-header-main" }
const _hoisted_153 = { class: "ehp-texts" }
const _hoisted_154 = { class: "ehp-subtitle" }
const _hoisted_155 = { style: {"padding":"16px","display":"flex","flex-direction":"column","gap":"12px"} }
const _hoisted_156 = { style: {"display":"flex","gap":"12px"} }
const _hoisted_157 = {
  class: "aviz-field",
  style: {"flex":"1"}
}
const _hoisted_158 = {
  class: "aviz-field",
  style: {"flex":"1"}
}
const _hoisted_159 = { class: "aviz-field" }
const _hoisted_160 = { class: "aviz-field" }
const _hoisted_161 = { class: "ehp-wrapper" }
const _hoisted_162 = { class: "ehp-header" }
const _hoisted_163 = { class: "ehp-header-main" }
const _hoisted_164 = { class: "ehp-texts" }
const _hoisted_165 = { class: "ehp-subtitle" }
const _hoisted_166 = { style: {"padding":"16px","display":"flex","flex-direction":"column","gap":"12px"} }
const _hoisted_167 = { class: "aviz-field" }
const _hoisted_168 = { class: "aviz-field" }
const _hoisted_169 = { class: "aviz-field" }
const _hoisted_170 = { class: "aviz-field" }
const _hoisted_171 = { class: "aviz-field" }
const _hoisted_172 = { class: "ehp-wrapper" }
const _hoisted_173 = { class: "ehp-header" }
const _hoisted_174 = { class: "ehp-header-main" }
const _hoisted_175 = { class: "ehp-texts" }
const _hoisted_176 = { class: "ehp-title" }
const _hoisted_177 = { class: "ehp-subtitle" }
const _hoisted_178 = { class: "denumiri-body" }
const _hoisted_179 = { class: "meta-tooltip-label" }
const _hoisted_180 = { class: "meta-tooltip-text" }

import { ref, shallowRef, computed, watch, onMounted, onUnmounted, nextTick } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import * as signalR from '@microsoft/signalr';
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup';
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DxSwitch from 'devextreme-vue/switch';
import DxDataGrid, { DxColumn, DxEditing, DxStateStoring, DxToolbar, DxItem, DxLookup, DxSelection, DxRequiredRule } from 'devextreme-vue/data-grid';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { exportDataGrid } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import DxLoadPanel from 'devextreme-vue/load-panel';
import ProComenziService from '@/services/Comercial/ProComenzi';
import DOC_DocumenteService from '@/services/Documente/DOC_Documente';
import JwtServices from '@/services/JwtServices';
import http from '@/settings/apiSettings';
import { usePrintReport } from '@/composable/usePrintReport';

interface Props {
    comandaId: string;
    orderData?: Record<string, any>;
    isNew?: boolean;
    // Setat de PRO_ComenziView cât timp verifică el însuși dacă poate schimba tab-ul
    // (confirmSwitchAway) — evită ca auto-salvarea de mai jos să intervină concurent și
    // să salveze silențios exact linia pe care părintele vrea s-o trateze explicit
    // (Salvează/Renunță/Rămân).
    suppressAutoSave?: boolean;
}
interface DenumireRow {
    ProdusID: string;
    ProdusNume: string;
    ProdusCod: string;
    PartenerNume: string;
    Cod: string;
    Nume: string;
    _existentId: string | null;
    _originalCod: string;
    _originalNume: string;
}
interface StateBtn { text: string; stareNoua: string; type: string; needsMotiv: boolean; disabled?: boolean; disabledHint?: string; }

const NOTA_LIVRARE_DIRECTA = 'Livrare directă de la furnizor.';

interface ReceptieLinie {
    LinieId: string;
    ProdusNume: string;
    CantitateComandataOrig: number;
    CantitateAlreadyReceptionata: number;
    CantitateReceptionata: number;
    PretAchizitie: number | null;
}
interface RapidaLinie {
    cod: string;
    produs: any | null;
    gasit: boolean;
    cantitate: number;
    pretUnitar: number | null;
    pretLista: number | null;
    pretListaValutaId: string | null;
    furnizorId: string | null;
    pretFurnizor: number | null;
    pretFurnizorValutaId: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GridComandaDetalii',
  props: {
    comandaId: {},
    orderData: {},
    isNew: { type: Boolean },
    suppressAutoSave: { type: Boolean }
  },
  emits: ["open-order", "unsaved-changes-change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;

// ── Local state ──
const localOrderData = ref<Record<string, any> | null>(null);
const isLoading = ref(false);
const { isPrinting, printReport } = usePrintReport();
const categoriiComenzi = ref<any[]>([]);

const tipComandaNume = computed(() => {
    const tip = localOrderData.value?.Tipcomanda;
    if (tip == null) return null;
    return categoriiComenzi.value.find(c => c.TipComanda === tip)?.Denumire ?? null;
});

// ── SignalR — order presence lock ──
const hubConnection = ref<signalR.HubConnection | null>(null);
const editingByUser = ref<string | null>(null);

async function connectSignalR(orderId: string) {
    try {
        const conn = new signalR.HubConnectionBuilder()
            .withUrl(AppSetting.API_Url_ComercialSignalR)
            .withAutomaticReconnect()
            .build();

        conn.on('OrderLocked', (id: string, username: string) => {
            if (id === orderId) editingByUser.value = username;
        });
        conn.on('OrderUnlocked', (id: string) => {
            if (id === orderId) editingByUser.value = null;
        });

        await conn.start();

        let username = 'Utilizator';
        try { username = JwtServices.GetUsername(); } catch { /* ignore */ }

        const lockedBy = await conn.invoke<string | null>('LockOrder', orderId, username);
        if (lockedBy) editingByUser.value = lockedBy;

        hubConnection.value = conn;
    } catch (err) {
        console.warn('SignalR unavailable:', err);
    }
}

async function disconnectSignalR(orderId: string) {
    const conn = hubConnection.value;
    if (!conn) return;
    try { await conn.invoke('UnlockOrder', orderId); } catch { /* ignore */ }
    try { await conn.stop(); } catch { /* ignore */ }
    hubConnection.value = null;
    editingByUser.value = null;
}

let connectedOrderId: string | null = null;

async function syncSignalRConnection(orderId: string) {
    if (connectedOrderId === orderId) return;
    if (connectedOrderId) await disconnectSignalR(connectedOrderId);
    connectedOrderId = orderId;
    await connectSignalR(orderId);
}
const detaliiStore = shallowRef<any>(null);
const gridRef = ref<InstanceType<typeof DxDataGrid> | null>(null);
const dsProduse = {
    store: {
        type: 'odata',
        url: AppSetting.API_Url_ComercialOdata + 'PRO_Produse',
        key: 'Id',
        keyType: 'Guid',
        version: 4,
        beforeSend: (e: any) => {
            e.headers = { Authorization: 'Bearer ' + (localStorage.getItem('ERA_Jwt') ?? '') };
            e.params.$expand = 'PretValuta($select=Curs)';
        },
    },
    select: ['Id', 'Cod', 'CodIntern', 'Nume', 'PretVanzare', 'Pret', 'TvaCurent', 'GarantieLuni', 'PretValutaId'],
    paginate: true, pageSize: 30,
};

// ── Generare document ──
const showGenereazaDocPopup = ref(false);
const isGenereazandDoc = ref(false);
const genDocTipId = ref<string | null>(null);
const genDocData = ref<Date>(new Date());
const genDocObs = ref('');

const dsTipuriDoc = new DataSource({
    store: new ODataStore({
        url: AppSetting.API_Url_DocumenteOdata + 'DOC_Tipuri',
        key: 'Id',
        version: 4,
        beforeSend: (e: any) => {
            e.headers = { Authorization: 'Bearer ' + (localStorage.getItem('ERA_Jwt') ?? '') };
        },
    }),
    select: ['Id', 'Nume', 'Cod'],
    filter: ['AreComanda', '=', true],
    sort: [{ selector: 'Nume', desc: false }],
});

function onOpenGenereazaDocPopup() {
    genDocTipId.value = null;
    genDocData.value = new Date();
    genDocObs.value = localOrderData.value?.Observatii ?? '';
    showGenereazaDocPopup.value = true;
}

function onCloseGenereazaDocPopup() {
    showGenereazaDocPopup.value = false;
    genDocTipId.value = null;
    genDocData.value = new Date();
    genDocObs.value = '';
}

async function onGenereazaDocument() {
    if (!genDocTipId.value) return;
    isGenereazandDoc.value = true;
    try {
        const dto = {
            ComandaId: props.comandaId,
            TipDocumentId: genDocTipId.value,
            Data: genDocData.value,
            Observatii: genDocObs.value || null,
        };
        const resp = await DOC_DocumenteService.genereazaDocumentDinComanda(dto);
        const numar = resp.data?.Document?.Numar ?? '';
        onCloseGenereazaDocPopup();
        toast(`Documentul ${numar ? `nr. ${numar} ` : ''}a fost generat cu succes.`, 'success', 3000);
        const avertismente: string[] = resp.data?.Avertismente ?? [];
        for (const msg of avertismente) {
            toast(msg, 'warning', 6000);
        }
        await refreshLocalData();
        // Documentul generat generic poate fi orice tip (aviz, factură, NIR etc.) — reîmprospătăm
        // toate listele de documente ca să apară imediat în tab-ul corect (Avize/Facturi/Recepții
        // sau Documente generice), nu doar la reîncărcarea completă a paginii.
        await Promise.all([
            refreshCantitatiRezervate(), refreshStocuriProduse(),
            refreshAvize(), refreshFacturi(), refreshReceptii(), refreshComenziStorno(),
        ]);
        gridRef.value?.instance?.refresh();
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    } finally {
        isGenereazandDoc.value = false;
    }
}

// ── Drepturi granulare ──
const drepturi = ref({
    CreeazaComenzi: true, StergeComenzi: true, DuplicaComenzi: true,
    AnuleazaComenzi: true, AnuleazaFacturi: true, AnuleazaAvize: true, ModificaPretComenzi: true, RezervaComenzi: true,
    VedeToateComenzi: true, EditeazaComenzi: true, GenereazaAvize: true, ReceptioneazaMarfa: true, GenereazaFacturi: true,
});

// ── Rezervări ──
const isRezervandToate = ref(false);
const showRezervareLiniePopup = ref(false);
const rezervaLineId = ref('');
const rezervareLinieProdusNume = ref('');
const rezervareLinieProdusId = ref('');
const rezervareLinieCantitateMax = ref(0);
const rezervareLinieCantitate = ref(0);
const rezervareCantitateRef = ref<any>(null);
const cantitatiRezervate = shallowRef<Record<string, number>>({});
const stocuriProduse = shallowRef<Record<string, any>>({});
const calcCache = shallowRef<Record<string, any>>({});
const liniiGrid = ref<any[]>([]);
const liniiSelectate = ref<string[]>([]);
const isBatchEditMode = ref(false);
const isFullscreen = ref(false);

function toggleFullscreen() {
    isFullscreen.value = !isFullscreen.value;
}
const isGenerandStorno = ref(false);
const isRefreshingCurs = ref(false);
const cursEUR = ref<number | null>(null);
const cursUSD = ref<number | null>(null);

const metaTooltip = ref({ visible: false, style: {} as Record<string, string>, label: '', text: '' });

function showMetaTooltip(e: MouseEvent, label: string, text: string) {
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    metaTooltip.value = {
        visible: true,
        style: {
            top: `${rect.bottom + 8}px`,
            left: `${Math.min(rect.left, window.innerWidth - 420)}px`,
        },
        label,
        text,
    };
}

function hideMetaTooltip() {
    metaTooltip.value.visible = false;
}

async function loadCursuriValutare() {
    try {
        const [respEUR, respUSD] = await Promise.all([
            http.clientComercialOdata.get(`ERP_CursValutar?$filter=Simbol eq 'EUR'&$orderby=Data desc&$top=1&$select=Curs`),
            http.clientComercialOdata.get(`ERP_CursValutar?$filter=Simbol eq 'USD'&$orderby=Data desc&$top=1&$select=Curs`),
        ]);
        cursEUR.value = respEUR.data?.value?.[0]?.Curs ?? null;
        cursUSD.value = respUSD.data?.value?.[0]?.Curs ?? null;
    } catch { /* ignore */ }
}

// ── Ultimul curs BNR per valută (pentru coloana "Curs Pret Lista") ──
const latestCursuriByValuta = ref<Record<string, number>>({});

async function loadLatestCursuriToateValutele() {
    try {
        const resp = await http.clientComercialOdata.get(
            `ERP_CursValutar?$orderby=Data desc&$top=500&$select=ValutaID,Curs,Data`
        );
        const rows: any[] = resp.data?.value ?? [];
        const map: Record<string, number> = {};
        for (const r of rows) {
            if (r.ValutaID == null || r.Curs == null) continue;
            const key = String(r.ValutaID).toLowerCase();
            if (!(key in map)) map[key] = r.Curs;
        }
        latestCursuriByValuta.value = map;
    } catch { /* ignore */ }
}

// ── Eșalonări livrare ──
const showEsalonariPopup = ref(false);
const esalonariDetaliuId = ref<string | null>(null);
const esalonariDetaliuNume = ref('');
const esalonariStore = shallowRef<any>(null);
const esalonariGridRef = ref<InstanceType<typeof DxDataGrid> | null>(null);

const esalonareStatusuri = [
    { Id: 1, Denumire: 'Așteptare' },
    { Id: 2, Denumire: 'Rezervată' },
    { Id: 3, Denumire: 'Programat Incomplet' },
    { Id: 4, Denumire: 'Programată' },
    { Id: 5, Denumire: 'Lansat Incomplet' },
    { Id: 6, Denumire: 'Lansată' },
    { Id: 7, Denumire: 'Închisă' },
    { Id: 8, Denumire: 'Anulată' },
];

const ESALONARE_STATUS_COLORS: Record<number, { bg: string; color: string }> = {
    1: { bg: '#f1f5f9', color: '#475569' },
    2: { bg: '#eff6ff', color: '#1d4ed8' },
    3: { bg: '#fef3c7', color: '#92400e' },
    4: { bg: '#ecfdf5', color: '#065f46' },
    5: { bg: '#fef3c7', color: '#92400e' },
    6: { bg: '#dcfce7', color: '#166534' },
    7: { bg: '#f1f5f9', color: '#64748b' },
    8: { bg: '#fef2f2', color: '#991b1b' },
};

function getEsalonareStatusNume(status: number | null | undefined): string {
    if (status == null) return '—';
    return esalonareStatusuri.find(s => s.Id === status)?.Denumire ?? String(status);
}

function getEsalonareStatusStyle(status: number | null | undefined): Record<string, string> {
    const t = ESALONARE_STATUS_COLORS[status ?? 0] ?? { bg: '#f1f5f9', color: '#475569' };
    return {
        background: t.bg, color: t.color,
        padding: '2px 8px', borderRadius: '12px', fontWeight: '600',
        fontSize: '11px', whiteSpace: 'nowrap',
    };
}

// ── Denumiri personalizate produse ──────────────────────────────────────────
const showDenumiriPopup = ref(false);
const isSavingDenumiri = ref(false);
const denumiriGridRef = ref<InstanceType<typeof DxDataGrid> | null>(null);
const denumiriProdusNume = ref('');

const denumiriRows = ref<DenumireRow[]>([]);

const toateRezervate = computed(() => {
    // Comenzile drop-ship (LivrareDirectaFurnizor) nu trec prin gestiunea proprie — nu are
    // sens să cerem rezervare de stoc intern, la fel ca la validarea din backend.
    if (localOrderData.value?.LivrareDirectaFurnizor) return true;
    const liniiActive = liniiGrid.value.filter(l => l.ProdusID && !l.Anulata);
    if (liniiActive.length === 0) return false;
    return liniiActive.every(l => (cantitatiRezervate.value[l.ID] ?? 0) >= (l.Cantitate ?? 0));
});

// "Generează document" cere comanda Confirmata sau InLucru și complet rezervată — mesajul
// explică exact ce condiție lipsește.
const STARI_PERMISE_GENEREAZA_DOC = ['Confirmata', 'InLucru'];
const genereazaDocDisabledHint = computed(() => {
    if (!STARI_PERMISE_GENEREAZA_DOC.includes(localOrderData.value?.Stare ?? ''))
        return 'Documentul poate fi generat doar cât timp comanda e Confirmată sau În Lucru.';
    if (!toateRezervate.value)
        return 'Comanda trebuie să fie complet rezervată pentru a genera documentul.';
    return undefined;
});

async function refreshCantitatiRezervate() {
    if (!props.comandaId) return;
    try {
        const resp = await ProComenziService.getCantitatiRezervate(props.comandaId);
        cantitatiRezervate.value = resp.data ?? {};
    } catch { cantitatiRezervate.value = {}; }
}

async function refreshStocuriProduse() {
    if (!props.comandaId) return;
    try {
        const resp = await ProComenziService.getStocuriProduse(props.comandaId);
        stocuriProduse.value = resp.data ?? {};
    } catch { stocuriProduse.value = {}; }
}

const isReadOnly = computed(() =>
    ['Finalizata', 'Anulata'].includes(localOrderData.value?.Stare ?? '') ||
    editingByUser.value !== null ||
    localOrderData.value?.Facturat === true
);

// Liniile comenzii nu mai pot fi editate/adăugate/șterse din grid odată intrată "În Lucru" —
// diferit de isReadOnly (care ar ascunde și "Rezervă toate"/"Refresh curs", butoane necesare
// tocmai în starea InLucru).
const liniiReadOnly = computed(() =>
    isReadOnly.value || localOrderData.value?.Stare === 'InLucru'
);

function canEditRow(options: any): boolean {
    if (liniiReadOnly.value) return false;
    return !options.row?.data?.DocumentID;
}

// Referință stabilă (nu se schimbă reactiv) — citește isBatchEditMode intern la execuție
function allowUpdatingFn(options: any): boolean {
    if (!isBatchEditMode.value) return false;
    return canEditRow(options);
}

function canDeleteRow(options: any): boolean {
    if (liniiReadOnly.value) return false;
    return !options.row?.data?.DocumentID;
}

// ── State machine ──
const currentCategorie = computed(() => {
    const tip = localOrderData.value?.Tipcomanda;
    if (tip == null) return null;
    return categoriiComenzi.value.find((c: any) => c.TipComanda === tip) ?? null;
});

const isClientOrder = computed(() => {
    return currentCategorie.value?.TipFurnizor !== true;
});

// Coduri TipComanda pentru comenzi storno — aceleași ca în backend
// (PRO_ComenziRepository.GenereazaStornoComanda: 3 = storno client, 9 = storno furnizor).
const isComandaStorno = computed(() => {
    const tip = localOrderData.value?.Tipcomanda;
    return tip === 3 || tip === 9;
});

const stateButtons = computed<StateBtn[]>(() => {
    switch (localOrderData.value?.Stare) {
        case 'InAsteptare': return [
            { text: 'Confirmă', stareNoua: 'Confirmata', type: 'default', needsMotiv: false },
        ];
        case 'Confirmata': return [
            { text: 'Marchează În Lucru', stareNoua: 'InLucru', type: 'default', needsMotiv: false },
            { text: 'Repune în Așteptare', stareNoua: 'InAsteptare', type: 'normal', needsMotiv: false },
        ];
        case 'InLucru': return [
            { text: 'Finalizează', stareNoua: 'Finalizata', type: 'success', needsMotiv: false },
            { text: 'Înapoi la Confirmată', stareNoua: 'Confirmata', type: 'normal', needsMotiv: false },
        ];
        default: return [];
    }
});

// Butonul "Anulează" e independent de switch-ul de mai sus — rămâne mereu vizibil cât timp
// comanda e într-o stare activă (nu deja Finalizata/Anulata), indiferent de restul tranzițiilor.
// E însă dezactivat (nu ascuns) dacă utilizatorul nu are dreptul AnuleazaComenzi — backend-ul
// verifică oricum dreptul la SchimbaStare (case "Anulata") și respinge cu eroare clară, dar
// dezactivarea din UI evită un click care oricum ar eșua.
const visibleStateButtons = computed(() => {
    const btns = [...stateButtons.value];
    const stare = localOrderData.value?.Stare;
    const poateAnula = !!stare && stare !== 'Anulata' && stare !== 'Finalizata';
    if (poateAnula) {
        btns.push({
            text: 'Anulează', stareNoua: 'Anulata', type: 'danger', needsMotiv: true,
            disabled: !drepturi.value.AnuleazaComenzi,
            disabledHint: !drepturi.value.AnuleazaComenzi ? 'Nu aveți dreptul de a anula comenzi.' : undefined,
        });
    }
    return btns;
});

const showMotivPopup = ref(false);
const motivText = ref('');
const pendingStare = ref('');

async function onStateButtonClick(btn: StateBtn) {
    // Storno (client/furnizor) nu rezervă stoc niciodată (blocat hard în backend,
    // PRO_RezervariRepository.IncarcaContextComanda) — la fel ca drop-ship, tranziția în
    // InLucru nu trebuie condiționată de rezervare. Pentru storno client, singura precondiție
    // reală pentru facturare e recepția (NIR) — verificată separat de backend în GenereazaFactura.
    if (btn.stareNoua === 'InLucru' && !localOrderData.value?.LivrareDirectaFurnizor && !isComandaStorno.value) {
        const linii: any[] = gridRef.value?.instance?.getDataSource().items() ?? [];
        // Serviciile (Produs.Stocabil=false) nu se rezervă niciodată — doar produsele stocabile
        // trebuie verificate înainte de a permite tranziția în InLucru.
        const liniiActive = linii.filter(l => l.ProdusID && !l.Anulata && l.Produs?.Stocabil !== false);
        const nerezervate = liniiActive.filter(l => (cantitatiRezervate.value[l.ID] ?? 0) < (l.Cantitate ?? 0));
        if (nerezervate.length > 0) {
            toast(`${nerezervate.length} produs(e) nu sunt rezervate complet. Comanda trebuie să fie complet rezervată pentru a fi pusă în lucru.`, 'error', 4000);
            return;
        }
    }
    if (btn.stareNoua === 'Anulata') {
        const ok = await custom({
            title: 'Confirmare anulare',
            messageHtml: 'Ești sigur că vrei să anulezi această comandă? Acțiunea este ireversibilă.',
            buttons: [
                { text: 'Da, anulează', type: 'danger', onClick: () => true },
                { text: 'Nu', stylingMode: 'outlined', onClick: () => false },
            ],
        }).show();
        if (!ok) return;
    }
    if (btn.needsMotiv) {
        pendingStare.value = btn.stareNoua;
        motivText.value = '';
        showMotivPopup.value = true;
    } else {
        doSchimbaStare(btn.stareNoua);
    }
}

function onConfirmMotiv() {
    if (!motivText.value.trim()) {
        toast('Motivul este obligatoriu.', 'warning', 2000);
        return;
    }
    showMotivPopup.value = false;
    doSchimbaStare(pendingStare.value, motivText.value.trim());
}

async function doSchimbaStare(stareNoua: string, motiv?: string) {
    try {
        await ProComenziService.schimbaStare(props.comandaId, stareNoua, motiv);
        await refreshLocalData();
        toast(`Starea a fost schimbată în '${stareNoua}'.`, 'success', 2000);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    }
}

// ── Header edit ──
const showEditHeaderPopup = ref(false);
const isSavingHeader = ref(false);
const headerDraft = ref<{
    ClientId: string | null; AgentId: string | null; ValutaId: string | null;
    Tipcomanda: number | null; DataComenzii: any; TermenLivrare: any; Observatii: string;
    ProiectId: string | null; LivrareDirectaFurnizor: boolean;
}>({
    ClientId: null, AgentId: null, ValutaId: null, Tipcomanda: null,
    DataComenzii: null, TermenLivrare: null, Observatii: '', ProiectId: null,
    LivrareDirectaFurnizor: false,
});

const dsParteneriHeader = shallowRef<DataSource | null>(null);
const dsAgenti = ref<DataSource | null>(null);
const dsValute = ref<DataSource | null>(null);
const dsProiecte = shallowRef<DataSource | null>(null);

const dsValuteLookup = new ODataStore({
    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
    key: 'Id',
    version: 4,
    beforeSend: (e: any) => {
        e.headers = { Authorization: 'Bearer ' + (localStorage.getItem('ERA_Jwt') ?? '') };
    },
});

function initEditHeaderDataSources() {
    if (dsAgenti.value && dsValute.value) return;
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; };
    dsAgenti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Agenti', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
    dsValute.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Simbol', 'Nume'],
        sort: [{ selector: 'Simbol', desc: false }],
    });
    dsProiecte.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'DOC_Proiecte', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Cod', 'Nume'],
        sort: [{ selector: 'Cod', desc: false }],
        paginate: true,
        pageSize: 30,
    });
}

function onToggleLivrareDirectaFurnizor(e: any) {
    if (!e.event) return; // ignoră setările programatice (populare headerDraft la deschiderea popup-ului)
    const current = (headerDraft.value.Observatii || '').trim();
    if (e.value) {
        if (!current.includes(NOTA_LIVRARE_DIRECTA)) {
            headerDraft.value.Observatii = current ? `${current} ${NOTA_LIVRARE_DIRECTA}` : NOTA_LIVRARE_DIRECTA;
        }
    } else {
        headerDraft.value.Observatii = current.replace(NOTA_LIVRARE_DIRECTA, '').replace(/\s{2,}/g, ' ').trim();
    }
}

const partenerLabelHeader = computed(() => {
    // Tipcomanda=0 e o categorie validă ("Comercial Clienti" în nomenclatorul legacy) — nu se
    // poate testa cu `!Tipcomanda`, altfel 0 e tratat greșit ca "lipsă" (falsy) și eticheta
    // rămâne "Partener", ascunzând switch-ul "Livrare directă de la furnizor" de mai jos.
    if (headerDraft.value.Tipcomanda == null) return 'Partener';
    const cat = categoriiComenzi.value.find(c => c.TipComanda === headerDraft.value.Tipcomanda);
    return cat?.TipFurnizor === true ? 'Furnizor' : 'Client';
});

function buildDsParteneriHeader(tipFurnizor?: boolean | null) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; };
    const filter = tipFurnizor === true ? ['Furnizor', '=', true] : ['Client', '=', true];
    dsParteneriHeader.value = new DataSource({
        store: new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
            key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
        }),
        select: ['ID', 'Nume', 'CUI', 'ValutaID'],
        filter,
        sort: [{ selector: 'Nume', desc: false }],
        paginate: true,
        pageSize: 30,
    });
}

function onTipComandaHeaderChanged(e: any) {
    if (!e.value) { dsParteneriHeader.value = null; return; }
    const cat = categoriiComenzi.value.find(c => c.TipComanda === e.value);
    buildDsParteneriHeader(cat?.TipFurnizor);
    headerDraft.value.ClientId = null;
}

function onPartenerHeaderChanged(e: any) {
    if (!e.selectedItem) return;
    const valutaPartener = e.selectedItem.ValutaID ?? null;
    if (valutaPartener) headerDraft.value.ValutaId = valutaPartener;
}

function onEditHeader() {
    initEditHeaderDataSources();
    headerDraft.value = {
        ClientId: localOrderData.value?.ClientId ?? null,
        AgentId: localOrderData.value?.AgentId ?? null,
        ValutaId: localOrderData.value?.ValutaId ?? null,
        Tipcomanda: localOrderData.value?.Tipcomanda ?? null,
        DataComenzii: localOrderData.value?.DataComenzii ?? null,
        TermenLivrare: localOrderData.value?.TermenLivrare ?? null,
        Observatii: localOrderData.value?.Observatii ?? '',
        ProiectId: localOrderData.value?.ProiectId ?? null,
        LivrareDirectaFurnizor: localOrderData.value?.LivrareDirectaFurnizor ?? false,
    };
    const cat = categoriiComenzi.value.find(c => c.TipComanda === headerDraft.value.Tipcomanda);
    buildDsParteneriHeader(cat?.TipFurnizor);
    showEditHeaderPopup.value = true;
}

async function onSaveHeader() {
    isSavingHeader.value = true;
    try {
        await ProComenziService.patchComanda(props.comandaId, {
            ClientId: headerDraft.value.ClientId,
            AgentId: headerDraft.value.AgentId,
            ValutaId: headerDraft.value.ValutaId,
            Tipcomanda: headerDraft.value.Tipcomanda,
            DataComenzii: headerDraft.value.DataComenzii,
            TermenLivrare: headerDraft.value.TermenLivrare || null,
            Observatii: headerDraft.value.Observatii || null,
            ProiectId: headerDraft.value.ProiectId || null,
            LivrareDirectaFurnizor: partenerLabelHeader.value === 'Client' ? headerDraft.value.LivrareDirectaFurnizor : false,
        });
        await refreshLocalData();
        showEditHeaderPopup.value = false;
        toast('Comanda a fost actualizată.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3000);
    } finally {
        isSavingHeader.value = false;
    }
}

function onCancelHeaderEdit() {
    showEditHeaderPopup.value = false;
}

// ── Tab activ documente ──
const activeDocTab = ref<string | null>(null);
function toggleDocTab(tab: string) {
    activeDocTab.value = activeDocTab.value === tab ? null : tab;
}

// ── Documente generate ──

// ── Rezervări (documente hold, temporare) ──
const rezervari = ref<any[]>([]);

async function refreshRezervari() {
    if (!props.comandaId) return;
    try {
        const resp = await ProComenziService.getRezervari(props.comandaId);
        rezervari.value = resp.data ?? [];
    } catch { rezervari.value = []; }
}

// ── Avize expediție ──
const avize = ref<any[]>([]);
const showGenereazaAvizPopup = ref(false);
const isGenereazaAviz = ref(false);

// Oglindă în frontend a blocajului din backend (GenereazaAviz: "există deja un aviz activ")
// — butonul se dezactivează proactiv, nu doar la eroarea din backend după click.
const existaAvizActiv = computed(() => avize.value.some((a: any) => !a.Anulat));
const avizFormData = ref({
    Data: new Date() as Date | null,
    GestiuneId: null as string | null,
    ExpediereNume: '',
    ExpediereMijloc: '',
    Observatii: '',
});

const dsGestiuni = new DataSource({
    store: new ODataStore({
        url: AppSetting.API_Url_DocumenteOdata + 'GES_Gestiuni',
        key: 'Id',
        keyType: 'Guid',
        version: 4,
        beforeSend: (e: any) => {
            e.headers = { Authorization: 'Bearer ' + (localStorage.getItem('ERA_Jwt') ?? '') };
        },
    }),
    select: ['Id', 'Nume'],
    sort: [{ selector: 'Nume', desc: false }],
});

async function refreshAvize() {
    if (!props.comandaId) return;
    try {
        const resp = await ProComenziService.getAvize(props.comandaId);
        avize.value = resp.data ?? [];
    } catch { avize.value = []; }
}

function onOpenGenereazaAvizPopup() {
    avizFormData.value = {
        Data: new Date(),
        GestiuneId: null,
        ExpediereNume: '',
        ExpediereMijloc: '',
        Observatii: '',
    };
    showGenereazaAvizPopup.value = true;
}

async function onConfirmGenereazaAviz() {
    isGenereazaAviz.value = true;
    try {
        const dto = {
            Data: avizFormData.value.Data,
            GestiuneId: avizFormData.value.GestiuneId ?? null,
            ExpediereNume: avizFormData.value.ExpediereNume || null,
            ExpediereMijloc: avizFormData.value.ExpediereMijloc || null,
            Observatii: avizFormData.value.Observatii || null,
        };
        const resp = await ProComenziService.genereazaAviz(props.comandaId, dto);
        const aviz = resp.data;
        showGenereazaAvizPopup.value = false;
        toast(`Aviz nr. ${aviz?.Numar ?? ''} generat cu succes.`, 'success', 3000);
        // Generarea avizului eliberează automat rezervarea (vezi ElibereazaRezervarile din backend)
        // — reîmprospătăm și tab-ul de Rezervări ca să reflecte imediat statusul "Anulată".
        await Promise.all([refreshAvize(), refreshRezervari(), refreshLocalData()]);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    } finally {
        isGenereazaAviz.value = false;
    }
}

async function onTiparesteAviz(avizItem: any) {
    const clasaRaport: string | null | undefined = avizItem.Tip?.ClasaRaport;
    if (!clasaRaport) {
        toast('Tipul avizului nu are un raport configurat (ClasaRaport lipsă).', 'warning', 3000);
        return;
    }
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const params = new URLSearchParams({ clasaRaport, documentID: avizItem.Id });
    const url = `${AppSetting.API_Url_Rapoarte}report/GetReportByClasaRaport?${params}`;
    const ok = await printReport(url, token);
    if (!ok) toast('Raportul nu a putut fi generat.', 'error', 3000);
}

async function onAnuleazaAviz(avizItem: any) {
    const ok = await custom({
        title: 'Anulare aviz',
        messageHtml: `<div style="padding:4px 0">Ești sigur că vrei să anulezi avizul <b>${avizItem.Numar ?? ''}</b>?</div>`,
        buttons: [
            { text: 'Da, anulează', type: 'danger', onClick: () => true },
            { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    try {
        await ProComenziService.anuleazaAviz(props.comandaId, avizItem.Id);
        toast('Avizul a fost anulat.', 'success', 2000);
        await Promise.all([refreshAvize(), refreshLocalData()]);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    }
}

// ── Recepții (NIR) ──
const receptii = ref<any[]>([]);
const showReceptiePopup = ref(false);
const isGenereazaReceptie = ref(false);
const receptieFormData = ref({
    Data: new Date() as Date | null,
    GestiuneId: null as string | null,
    Observatii: '',
});

const receptieLinii = ref<ReceptieLinie[]>([]);

async function refreshReceptii() {
    if (!props.comandaId) return;
    try {
        const resp = await ProComenziService.getReceptii(props.comandaId);
        receptii.value = resp.data ?? [];
    } catch { receptii.value = []; }
}

async function onOpenReceptiePopup() {
    receptieFormData.value = { Data: new Date(), GestiuneId: null, Observatii: '' };

    let cantitatiReceptionate: Record<string, number> = {};
    try {
        const resp = await ProComenziService.getCantitatiReceptionate(props.comandaId);
        cantitatiReceptionate = resp.data ?? {};
    } catch { /* ignore */ }

    receptieLinii.value = liniiGrid.value
        .filter((l: any) => !l.Anulata && l.ProdusID)
        .map((l: any) => {
            const alreadyReceived = cantitatiReceptionate[l.ID] ?? 0;
            const remaining = Math.max(0, (l.Cantitate ?? 0) - alreadyReceived);
            return {
                LinieId: l.ID,
                ProdusNume: l.ProdusNume ?? l.Produs?.Nume ?? '',
                CantitateComandataOrig: l.Cantitate ?? 0,
                CantitateAlreadyReceptionata: alreadyReceived,
                CantitateReceptionata: remaining,
                PretAchizitie: l.FurnizorPret ?? null,
            } as ReceptieLinie;
        });

    showReceptiePopup.value = true;
}

async function onConfirmReceptie() {
    const liniiDeTrimis = receptieLinii.value.filter(l => l.CantitateReceptionata > 0);
    if (liniiDeTrimis.length === 0) {
        toast('Introduceți cel puțin o cantitate recepționată.', 'warning', 3000);
        return;
    }
    isGenereazaReceptie.value = true;
    try {
        const dto = {
            Data: receptieFormData.value.Data,
            GestiuneId: receptieFormData.value.GestiuneId ?? null,
            Observatii: receptieFormData.value.Observatii || null,
            Linii: liniiDeTrimis.map(l => ({
                LinieId: l.LinieId,
                CantitateReceptionata: l.CantitateReceptionata,
                PretAchizitie: l.PretAchizitie ?? null,
            })),
        };
        const resp = await ProComenziService.genereazaReceptie(props.comandaId, dto);
        const nir = resp.data;
        showReceptiePopup.value = false;
        toast(`NIR nr. ${nir?.Numar ?? ''} generat cu succes.`, 'success', 3000);
        await Promise.all([refreshReceptii(), refreshRezervari(), refreshLocalData()]);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    } finally {
        isGenereazaReceptie.value = false;
    }
}

async function onTiparesteNir(nirItem: any) {
    const clasaRaport: string | null | undefined = nirItem.Tip?.ClasaRaport;
    if (!clasaRaport) {
        toast('Tipul NIR-ului nu are un raport configurat (ClasaRaport lipsă).', 'warning', 3000);
        return;
    }
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const params = new URLSearchParams({ clasaRaport, documentID: nirItem.Id });
    const url = `${AppSetting.API_Url_Rapoarte}report/GetReportByClasaRaport?${params}`;
    const ok = await printReport(url, token);
    if (!ok) toast('Raportul NIR nu a putut fi generat.', 'error', 3000);
}

// ── Facturi ──
const facturi = ref<any[]>([]);
const showGenereazaFacturaPopup = ref(false);
const isGenereazaFactura = ref(false);
const facturaFormData = ref({
    Data: new Date() as Date | null,
    Scadenta: null as Date | null,
    AvizId: null as string | null,
    Observatii: '',
});

async function refreshFacturi() {
    if (!props.comandaId) return;
    try {
        const resp = await ProComenziService.getFacturi(props.comandaId);
        facturi.value = resp.data ?? [];
    } catch { facturi.value = []; }
}

const comenziStorno = ref<any[]>([]);

async function refreshComenziStorno() {
    if (!props.comandaId) return;
    try {
        const resp = await ProComenziService.getComenziStorno(props.comandaId);
        comenziStorno.value = resp.data ?? [];
    } catch { comenziStorno.value = []; }
}

function onOpenGenereazaFacturaPopup() {
    const primulAvizValid = avize.value.find((a: any) => !a.Anulat);
    facturaFormData.value = {
        Data: new Date(),
        Scadenta: null,
        AvizId: primulAvizValid?.Id ?? null,
        Observatii: '',
    };
    showGenereazaFacturaPopup.value = true;
}

async function onConfirmGenereazaFactura() {
    isGenereazaFactura.value = true;
    try {
        const dto = {
            Data: facturaFormData.value.Data,
            Scadenta: facturaFormData.value.Scadenta ?? null,
            AvizId: facturaFormData.value.AvizId ?? null,
            Observatii: facturaFormData.value.Observatii || null,
        };
        const resp = await ProComenziService.genereazaFactura(props.comandaId, dto);
        const factura = resp.data;
        showGenereazaFacturaPopup.value = false;
        toast(`Factura nr. ${factura?.Numar ?? ''} generată cu succes.`, 'success', 3000);
        await Promise.all([refreshFacturi(), refreshLocalData()]);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    } finally {
        isGenereazaFactura.value = false;
    }
}

async function onStorneazaFactura(facturaItem: any) {
    const ok = await custom({
        title: 'Stornare factură',
        messageHtml: `<div style="padding:4px 0">Ești sigur că vrei să stornezi factura <b>${facturaItem.Numar ?? ''}</b>?</div>`,
        buttons: [
            { text: 'Da, stornează', type: 'danger', onClick: () => true },
            { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    try {
        const resp = await ProComenziService.storneazaFactura(props.comandaId, facturaItem.Id);
        toast(`Storno nr. ${resp.data?.Numar ?? ''} generat.`, 'success', 3000);
        await Promise.all([refreshFacturi(), refreshLocalData()]);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    }
}

async function onAnuleazaFactura(facturaItem: any) {
    const ok = await custom({
        title: 'Anulare factură',
        messageHtml: `<div style="padding:4px 0">Ești sigur că vrei să anulezi factura <b>${facturaItem.Numar ?? ''}</b>? Acțiunea nu generează document de corecție și este ireversibilă.</div>`,
        buttons: [
            { text: 'Da, anulează', type: 'danger', onClick: () => true },
            { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    try {
        await ProComenziService.anuleazaFactura(props.comandaId, facturaItem.Id);
        toast('Factura a fost anulată.', 'success', 2000);
        await Promise.all([refreshFacturi(), refreshLocalData()]);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    }
}

async function onTiparesteFactura(facturaItem: any) {
    const clasaRaport: string | null | undefined = facturaItem.Tip?.ClasaRaport;
    if (!clasaRaport) {
        toast('Tipul facturii nu are un raport configurat (ClasaRaport lipsă).', 'warning', 3000);
        return;
    }
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const params = new URLSearchParams({ clasaRaport, documentID: facturaItem.Id });
    const url = `${AppSetting.API_Url_Rapoarte}report/GetReportByClasaRaport?${params}`;
    const ok = await printReport(url, token);
    if (!ok) toast('Factura nu a putut fi generată ca PDF.', 'error', 3000);
}

// Certificatul de garanție e un raport fix (ro.sold.erp.DOC_CertificatGarantie), independent de
// Tip.ClasaRaport al facturii — se generează din aceleași linii de document ca factura.
async function onTipareasteCertificatGarantie(facturaItem: any) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const params = new URLSearchParams({ clasaRaport: 'ro.sold.erp.DOC_CertificatGarantie', documentID: facturaItem.Id });
    const url = `${AppSetting.API_Url_Rapoarte}report/GetReportByClasaRaport?${params}`;
    const ok = await printReport(url, token);
    if (!ok) toast('Certificatul de garanție nu a putut fi generat ca PDF.', 'error', 3000);
}

const documentsGenerate = computed(() => {
    // Avize, facturi și recepții (NIR) sunt sursa de adevăr pentru tipurile lor — au propriile
    // tab-uri cu acțiuni dedicate (tipărire, anulare/stornare). Tab-ul "Documente" rămâne doar
    // fallback pentru documente generate din comandă cu alt tip (ex: proformă, alt document
    // custom neconfigurat pe categorie) — nu mai duplică avize/facturi/NIR aici.
    const tipCoduriAcoperite = new Set(
        [...avize.value, ...facturi.value, ...receptii.value].map(d => d.Tip?.Cod).filter(Boolean)
    );

    const seen = new Set<string>();
    const docs: { DocumentID: string; Numar: string; TipCod: string; TipNume: string }[] = [];
    for (const l of liniiGrid.value) {
        const tipCod = l.Document?.Tip?.Cod;
        if (l.DocumentID && !seen.has(l.DocumentID) && !(tipCod && tipCoduriAcoperite.has(tipCod))) {
            seen.add(l.DocumentID);
            docs.push({
                DocumentID: l.DocumentID,
                Numar: l.Document?.Numar ?? '',
                TipCod: l.Document?.Tip?.Cod ?? '',
                TipNume: l.Document?.Tip?.Nume ?? '',
            });
        }
    }
    return docs;
});

function onOpenDocument(doc: any) {
    // Nume fix de fereastră — reutilizează același tab de browser la apeluri succesive;
    // Documente.vue adaugă documentul ca tab intern nou (vezi mounted() → query ?id=).
    window.open(`/documente?id=${doc.DocumentID}`, 'era_documente_tab');
}

const dsFurnizoriPO = shallowRef<DataSource | null>(null);

function buildDsFurnizoriPO() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; };
    dsFurnizoriPO.value = new DataSource({
        store: new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
            key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
        }),
        select: ['ID', 'Nume'],
        filter: ['Furnizor', '=', true],
        sort: [{ selector: 'Nume', desc: false }],
        paginate: true,
        pageSize: 30,
    });
}

// ── Adăugare rapidă linii ──
const showAdaugareRapidaPopup = ref(false);
const rapida_coduri = ref('');
const rapida_linii = ref<RapidaLinie[]>([]);
const rapida_isProcessing = ref(false);
const rapida_isAdaugand = ref(false);
const rapidaTextareaRef = ref<HTMLTextAreaElement | null>(null);

const rapida_liniiGasite = computed(() => rapida_linii.value.filter(l => l.gasit));
const rapida_liniiNegasite = computed(() => rapida_linii.value.filter(l => !l.gasit));

let rapidaTimer: ReturnType<typeof setTimeout> | null = null;
watch(rapida_coduri, (val) => {
    if (!val.trim()) { rapida_linii.value = []; return; }
    if (rapidaTimer) clearTimeout(rapidaTimer);
    rapidaTimer = setTimeout(() => procesezaCoduri(), 500);
});

watch(showAdaugareRapidaPopup, (val) => {
    if (val) nextTick(() => rapidaTextareaRef.value?.focus());
});

function onDetaliiCellPrepared(e: any) {
    if (e.rowType !== 'header' || !e.column?.hint) return;
    if (e.cellElement.querySelector('.col-info-icon')) return;

    // Iconița se pune direct pe celula de header (nu pe .dx-datagrid-text-content,
    // care are overflow:hidden și ar ascunde-o pe coloanele înguste) — poziționată
    // absolut, rămâne mereu vizibilă indiferent de lățimea coloanei.
    e.cellElement.classList.add('header-with-info');

    const icon = document.createElement('i');
    icon.className = 'dx-icon-info col-info-icon';
    icon.addEventListener('mouseenter', (ev: Event) => showMetaTooltip(ev as MouseEvent, e.column.caption ?? '', e.column.hint));
    icon.addEventListener('mouseleave', hideMetaTooltip);
    e.cellElement.appendChild(icon);
}

function onDetaliiContextMenuPreparing(e: any) {
    if (e.row?.rowType === 'header') return;
    const row = e.row?.data;
    const items: any[] = [];

    if (row?.ID) {
        items.push({
            text: 'Eșalonări livrare',
            icon: 'clock',
            onItemClick: () => onOpenEsalonari(row),
        });
    }

    if (row?.ProdusID && localOrderData.value?.ClientId) {
        items.push({
            text: 'Denumire partener',
            icon: 'user',
            onItemClick: () => onOpenDenumiriPersonalizate(row),
        });
    }

    if (!isReadOnly.value) {
        items.push({
            text: 'Import linii din Excel',
            icon: 'add',
            onItemClick: () => {
                rapida_coduri.value = '';
                rapida_linii.value = [];
                if (!dsFurnizoriPO.value) buildDsFurnizoriPO();
                showAdaugareRapidaPopup.value = true;
            },
        });
    }

    if (items.length > 0) e.items = items;
}

async function procesezaCoduri() {
    const coduri = rapida_coduri.value
        .split('\n')
        .map(c => c.trim())
        .filter(c => c.length > 0);
    if (coduri.length === 0) { rapida_linii.value = []; return; }
    rapida_isProcessing.value = true;
    try {
        // Deduplicate preserving original case
        const seenLower = new Set<string>();
        const unice: string[] = [];
        for (const cod of coduri) {
            if (!seenLower.has(cod.toLowerCase())) {
                seenLower.add(cod.toLowerCase());
                unice.push(cod);
            }
        }

        const filterStr = unice
            .map(c => `(Cod eq '${c.replace(/'/g, "''")}' or CodIntern eq '${c.replace(/'/g, "''")}')`)
            .join(' or ');

        const resp = await http.clientComercialOdata.get('PRO_Produse', {
            params: {
                '$filter': filterStr,
                '$select': 'Id,Cod,CodIntern,Nume,PretVanzare,Pret,TvaCurent,GarantieLuni,PretValutaId',
            },
        });
        const produse: any[] = resp.data?.value ?? [];

        rapida_linii.value = coduri.map(cod => {
            const produs = produse.find(p =>
                p.Cod?.toLowerCase() === cod.toLowerCase() ||
                p.CodIntern?.toLowerCase() === cod.toLowerCase()
            ) ?? null;
            return {
                cod,
                produs,
                gasit: !!produs,
                cantitate: 1,
                pretUnitar: produs ? (produs.PretVanzare ?? null) : null,
                pretLista: null,
                pretListaValutaId: produs?.PretValutaId ?? null,
                furnizorId: null,
                pretFurnizor: produs ? (produs.Pret ?? produs.PretVanzare ?? null) : null,
                pretFurnizorValutaId: produs?.PretValutaId ?? null,
            };
        });
    } catch {
        const coduri2 = rapida_coduri.value.split('\n').map(c => c.trim()).filter(c => c.length > 0);
        rapida_linii.value = coduri2.map(cod => ({ cod, produs: null, gasit: false, cantitate: 1, pretUnitar: null, pretLista: null, pretListaValutaId: null, furnizorId: null, pretFurnizor: null, pretFurnizorValutaId: null }));
    } finally {
        rapida_isProcessing.value = false;
    }
}

async function onAdaugaToate() {
    const gasite = rapida_liniiGasite.value;
    if (gasite.length === 0) return;
    rapida_isAdaugand.value = true;
    let adaugate = 0;
    try {
        for (const linie of gasite) {
            await ProComenziService.adaugaLinie({
                ComandaID: props.comandaId,
                ProdusID: linie.produs.Id,
                ProdusNume: linie.produs.Nume,
                Cantitate: linie.cantitate ?? 1,
                PretUnitar: linie.pretUnitar ?? 0,
                PretNegociat: linie.pretUnitar ?? 0,
                PretLista: linie.pretLista ?? null,
                PretListaValutaID: linie.pretListaValutaId ?? null,
                TVA: linie.produs.TvaCurent ?? 19,
                DiscountProc: 0,
                FurnizorID: linie.furnizorId ?? null,
                FurnizorPret: linie.pretFurnizor ?? null,
                FurnizorPretValutaID: linie.pretFurnizorValutaId ?? null,
                GarantieLuni: linie.produs.GarantieLuni ?? null,
            });
            adaugate++;
        }
        detaliiStore.value?.reload();
        refreshLocalData();
        toast(`${adaugate} linie(i) adăugate cu succes.`, 'success', 2000);
        rapida_coduri.value = '';
        rapida_linii.value = [];
        showAdaugareRapidaPopup.value = false;
    } catch (err: any) {
        if (adaugate > 0) {
            detaliiStore.value?.reload();
            refreshLocalData();
            toast(`${adaugate} din ${gasite.length} linii adăugate. ${getErrMsg(err)}`, 'warning', 5000);
        } else {
            toast(getErrMsg(err), 'error', 3000);
        }
    } finally {
        rapida_isAdaugand.value = false;
    }
}

// ── Grid CRUD ──
async function onRowInserting(e: any) {
    const data = { ...e.data };
    e.cancel = true;
    setTimeout(() => gridRef.value?.instance?.cancelEditData(), 0);

    try {
        await ProComenziService.adaugaLinie({
            ComandaID: props.comandaId,
            ProdusID: data.ProdusID ?? null,
            ProdusNume: data.ProdusNume ?? null,
            Cantitate: data.Cantitate ?? 1,
            PretNegociat: data.PretNegociat ?? 0,
            PretUnitar: data.PretUnitar ?? data.PretNegociat ?? 0,
            PretLista: data.PretLista ?? null,
            PretListaValutaID: data.PretListaValutaID ?? null,
            TVA: data.TVA ?? 19,
            DiscountProc: data.DiscountProc ?? 0,
            TermenLivrare: data.TermenLivrare ?? null,
            FurnizorID: data.FurnizorID ?? null,
            FurnizorPret: data.FurnizorPret ?? null,
            FurnizorPretValutaID: data.FurnizorPretValutaID ?? null,
            GarantieLuni: data.GarantieLuni ?? null,
        });
        detaliiStore.value?.reload();
        refreshLocalData();
        toast('Linia a fost adăugată.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3000);
    }
}

async function onRowUpdating(e: any) {
    const key = e.key;
    const newData = { ...e.newData };
    e.cancel = true;
    setTimeout(() => gridRef.value?.instance?.cancelEditData(), 0);

    try {
        await ProComenziService.patchLinie(key, newData);
        detaliiStore.value?.reload();
        refreshLocalData();
        toast('Linia a fost actualizată.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3000);
    }
}

async function onRowRemoving(e: any) {
    e.cancel = true;
    const ok = await custom({
        title: 'Confirmare ștergere',
        messageHtml: 'Ești sigur că vrei să ștergi această linie?',
        buttons: [
            { text: 'Da', type: 'danger', onClick: () => true },
            { text: 'Nu', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    try {
        await ProComenziService.stergeLinie(e.key);
        detaliiStore.value?.reload();
        refreshLocalData();
        toast('Linia a fost ștearsă.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3000);
    }
}

async function onStergeLiniiSelectate() {
    if (isReadOnly.value || liniiSelectate.value.length === 0) return;
    const count = liniiSelectate.value.length;
    const ok = await custom({
        title: 'Confirmare ștergere',
        messageHtml: `Ești sigur că vrei să ștergi <b>${count} linie(i) selectate</b>?`,
        buttons: [
            { text: 'Da', type: 'danger', onClick: () => true },
            { text: 'Nu', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    const ids = [...liniiSelectate.value];
    let errors = 0;
    for (const id of ids) {
        try {
            await ProComenziService.stergeLinie(id);
        } catch {
            errors++;
        }
    }
    liniiSelectate.value = [];
    gridRef.value?.instance?.clearSelection();
    detaliiStore.value?.reload();
    refreshLocalData();
    if (errors > 0) {
        toast(`${ids.length - errors} linie(i) șterse; ${errors} erori.`, 'warning', 3000);
    } else {
        toast(`${ids.length} linie(i) șterse.`, 'success', 1500);
    }
}

// ── Editare batch (toate liniile) ──

const hasUnsavedChanges = computed(() => {
    if (!isBatchEditMode.value) return false;
    const changes = gridRef.value?.instance?.option('editing.changes') ?? [];
    return (changes as any[]).length > 0;
});

watch(hasUnsavedChanges, (val) => {
    emit('unsaved-changes-change', val);
});

function onGridInitialized(e: any) {
    e.component.option('editing.allowAdding', !liniiReadOnly.value);
    (e.component.element() as HTMLElement).addEventListener('focusout', onGridFocusOut);
}

watch(liniiReadOnly, (readOnly) => {
    if (!readOnly) {
        isBatchEditMode.value = true;
    } else {
        gridRef.value?.instance?.cancelEditData();
        isBatchEditMode.value = false;
        calcCache.value = {};
    }
    gridRef.value?.instance?.option('editing.allowAdding', !readOnly);
}, { immediate: true });

function handleBeforeUnload(e: BeforeUnloadEvent) {
    if (hasUnsavedChanges.value) {
        e.preventDefault();
        e.returnValue = '';
    }
}

onBeforeRouteLeave(async (_to, _from, next) => {
    if (!hasUnsavedChanges.value) { next(); return; }
    const ok = await custom({
        title: 'Modificări nesalvate',
        messageHtml: 'Aveți modificări nesalvate. Sigur doriți să părăsiți pagina?',
        buttons: [
            { text: 'Rămân pe pagină', stylingMode: 'outlined', onClick: () => false },
            { text: 'Părăsesc pagina', type: 'danger', onClick: () => true },
        ],
    }).show();
    ok ? next() : next(false);
});

// Enter în grid apelează întotdeauna "Salvează tot" — singura protecție e împotriva
// interacțiunii cu dropdown-ul de produs, unde Enter-ul e pentru căutare/selecție, nu pentru
// salvare. Interogăm starea REALĂ a dropdown-ului (.option('opened')) în loc de un flag propriu
// (isProdusDropdownOpen) — evenimentul "closed" nu se declanșează fiabil la close() programatic,
// ceea ce lăsa flag-ul blocat pe true și bloca definitiv Enter-ul după prima selecție de produs.
function onGridKeyDown(e: any) {
    if (e.event?.key !== 'Enter') return;
    if (currentDropBoxInstance?.option('opened')) return;
    setTimeout(() => {
        if (currentDropBoxInstance?.option('opened')) return;
        onSalveazaTot();
    }, 0);
}

const isSalvandTot = ref(false);

async function onSalveazaTot() {
    if (isSalvandTot.value) return;
    const instance = gridRef.value?.instance;
    if (!instance) return;

    const changes = (instance.option('editing.changes') ?? []) as Array<{ type: string; key: string; data: any }>;

    if (changes.length === 0) {
        instance.cancelEditData();
        return;
    }

    isSalvandTot.value = true;
    try {
    let errors = 0;
    // "Refresh curs" se declanșează automat doar dacă vreo linie salvată implică o valută:
    // linie nouă cu preț de listă în valută, sau linie existentă unde s-a schimbat valuta.
    // Restul editărilor (cantitate, discount, observații etc.) nu ating cursul valutar.
    let necesitaRefreshCurs = false;
    for (const change of changes) {
        if (change.type === 'update') {
            const patchData = { ...change.data };
            // Pret Negociat nu se trimite niciodată — se derivă mereu pe backend din
            // Pret Unitar − Discount % (CalculeazaLinie). Pret Lista NU se mai forțează la
            // null când se editează Pret Unitar — backend-ul recalculează din Pret Lista
            // doar dacă acesta a fost efectiv modificat în acest PATCH (vezi UpdateDetaliu).
            delete patchData.PretNegociat;
            if ('PretListaValutaID' in patchData) necesitaRefreshCurs = true;
            try {
                await ProComenziService.patchLinie(change.key, patchData);
            } catch (err: any) {
                errors++;
                toast(getErrMsg(err), 'error', 3000);
            }
        } else if (change.type === 'insert') {
            const d = change.data;
            if (d.PretListaValutaID) necesitaRefreshCurs = true;
            try {
                await ProComenziService.adaugaLinie({
                    ComandaID: props.comandaId,
                    ProdusID: d.ProdusID ?? null,
                    ProdusNume: d.ProdusNume ?? null,
                    Cantitate: d.Cantitate ?? 1,
                    PretUnitar: d.PretUnitar ?? d.PretNegociat ?? 0,
                    PretLista: d.PretLista ?? null,
                    PretListaValutaID: d.PretListaValutaID ?? null,
                    TVA: d.TVA ?? 19,
                    DiscountProc: d.DiscountProc ?? 0,
                    TermenLivrare: d.TermenLivrare ?? null,
                    FurnizorID: d.FurnizorID ?? null,
                    FurnizorPret: d.FurnizorPret ?? null,
                    FurnizorPretValutaID: d.FurnizorPretValutaID ?? null,
                    GarantieLuni: d.GarantieLuni ?? null,
                });
            } catch (err: any) {
                errors++;
                toast(getErrMsg(err), 'error', 3000);
            }
        } else if (change.type === 'remove') {
            try {
                await ProComenziService.stergeLinie(change.key);
            } catch (err: any) {
                errors++;
                toast(getErrMsg(err), 'error', 3000);
            }
        }
    }

    instance.cancelEditData();
    calcCache.value = {};
    await instance.getDataSource()?.reload();
    await refreshLocalData();
    await Promise.all([refreshCantitatiRezervate(), refreshStocuriProduse()]);
    if (errors === 0 && necesitaRefreshCurs) await onRefreshCurs();
    instance.repaint();
    isBatchEditMode.value = !liniiReadOnly.value;
    if (errors === 0) toast('Modificările au fost salvate.', 'success', 1500);
    } finally {
        isSalvandTot.value = false;
    }
}

// ── Calcul instant coloane derivate (batch si row edit) ──
// NOTĂ: DevExtreme DxDataGrid nu are un eveniment "cellValueChanged" — varianta anterioară
// (@cell-value-changed) nu se declanșa niciodată. Interceptăm editoarele prin onEditorPreparing
// (pattern oficial DevExtreme pentru recalcul live), + separat pe coloana cu edit-cell-template
// custom (Valuta Pret Lista), care nu trece deloc prin onEditorPreparing.
const CALC_TRIGGER_FIELDS = ['Cantitate', 'PretUnitar', 'DiscountProc', 'TVA', 'PretLista', 'PretListaCurs'];

function onEditorPreparing(e: any) {
    if (e.parentType !== 'dataRow' || !CALC_TRIGGER_FIELDS.includes(e.dataField)) return;

    const defaultValueChangeHandler = e.editorOptions.onValueChanged;
    e.editorOptions.onValueChanged = function (args: any) {
        defaultValueChangeHandler(args);
        recalculeazaLinieLive({
            dataField: e.dataField,
            rowData: e.row?.data,
            rowKey: e.row?.key,
            rowIndex: e.row?.rowIndex,
            newValue: args.value,
        });
    };
}

async function recalculeazaLinieLive(params: { dataField: string; rowData: any; rowKey: any; rowIndex: number; newValue: any }) {
    const { dataField, rowData, rowKey, rowIndex, newValue } = params;
    const instance = gridRef.value?.instance;
    if (!instance || rowKey == null) return;

    const allChanges = (instance.option('editing.changes') ?? []) as Array<{ type: string; key: any; data: any }>;
    const rowChange = allChanges.find(c => c.key === rowKey);
    const currentData = {
        ...rowData,
        ...(rowChange?.data ?? {}),
        // editing.changes poate să nu reflecte încă valoarea tocmai introdusă în acest eveniment —
        // suprascriem explicit câmpul curent ca să nu calculăm pe date vechi.
        [dataField]: newValue,
    };

    // Când valuta prețului de listă se schimbă fără un PretLista ca bază de recalcul,
    // resetăm prețul unitar — nu există curs explicit pentru a converti un preț manual
    if (dataField === 'PretListaValutaID') {
        const hasPretLista = currentData.PretLista != null && Number(currentData.PretLista) > 0;
        if (!hasPretLista) {
            instance.cellValue(rowIndex, 'PretUnitar', null);
            instance.cellValue(rowIndex, 'PretNegociat', null);
            calcCache.value = { ...calcCache.value, [rowKey]: null };
            toast(
                'Valuta prețului de listă s-a schimbat. Prețul unitar a fost resetat — introduceți prețul manual.',
                'warning', 5000
            );
            return;
        }
    }

    // Dacă utilizatorul editează manual Pret Unitar, Pret Lista rămâne neschimbat
    // (informație de referință) — doar semnalăm backend-ului să nu-l mai recalculeze
    // din Pret Lista × Curs Pret Lista.
    const pretUnitarEditatManual = dataField === 'PretUnitar';

    const pretUnitarEfectiv = currentData.PretUnitar;

    try {
        const result = await ProComenziService.calculaLinie({
            PretUnitarEditatManual: pretUnitarEditatManual,
            Cantitate: currentData.Cantitate,
            PretUnitar: pretUnitarEfectiv,
            TVA: currentData.TVA,
            DiscountProc: currentData.DiscountProc,
            PretLista: currentData.PretLista,
            PretListaCurs: currentData.PretListaCurs,
            PretListaValutaID: currentData.PretListaValutaID ?? null,
        });
        calcCache.value = { ...calcCache.value, [rowKey]: result.data };
        // Pret Negociat = Pret Unitar − Pret Unitar × Discount% — întotdeauna calculat de backend
        // Îl propagăm în batch changes ca să fie salvat corect (coloana e read-only în grid)
        if (result.data?.PretNegociat != null)
            instance.cellValue(rowIndex, 'PretNegociat', result.data.PretNegociat);
        // Când Pret Lista + curs există, backend-ul poate recalcula și Pret Unitar — propagăm și pe acesta
        if (result.data?.PretUnitar != null)
            instance.cellValue(rowIndex, 'PretUnitar', result.data.PretUnitar);
        // Când valuta se schimbă și PretLista există, actualizează și cursul + notifică
        if (dataField === 'PretListaValutaID') {
            if (result.data?.PretListaCurs != null)
                instance.cellValue(rowIndex, 'PretListaCurs', result.data.PretListaCurs);
            if (result.data?.PretLista != null)
                instance.cellValue(rowIndex, 'PretLista', result.data.PretLista);
            if (result.data?.PretUnitar != null) {
                const curs = result.data?.PretListaCurs;
                const cursText = curs ? ` (curs: ${formatRO(curs)})` : '';
                toast(
                    `Prețul unitar recalculat: ${formatMoney(result.data.PretUnitar)}${cursText}`,
                    'info', 4000
                );
            }
        }
    } catch (err: any) {
        toast(`Recalcularea live a eșuat: ${getErrMsg(err)}`, 'error', 4000);
    }
}

// ── Selecție produs din dropdown cu coloane ──
let currentDropBoxInstance: any = null;
const innerProdusGridRef = ref<InstanceType<typeof DxDataGrid> | null>(null);
let shouldFocusFilter = false;

function onDropBoxOpened(e: any) {
    currentDropBoxInstance = e.component;
    shouldFocusFilter = true;
}

function onDropBoxClosed() {
    // currentDropBoxInstance rămâne — mai e nevoie de el pentru option('value')/close() ulterior
}

// Următoarea coloană editabilă, în ordinea VIZIBILĂ curentă a gridului (respectă coloanele
// activate din Column Chooser și reordonările făcute de utilizator) — nu o poziție fixă.
function getAdjacentEditableColumn(instance: any, fromDataField: string, direction: 1 | -1): string | null {
    const cols = ((instance?.getVisibleColumns?.() ?? []) as any[])
        .filter(c => c.visible !== false && c.allowEditing !== false && c.dataField);
    const idx = cols.findIndex(c => c.dataField === fromDataField);
    if (idx === -1) return null;
    const next = cols[idx + direction];
    return next?.dataField ?? null;
}

// Enter deschide dropdown-ul de căutare; Tab sare la următoarea coloană editabilă vizibilă —
// altfel Tab ar naviga mai întâi pe butonul "clear" (X) al DxDropDownBox, blocând parcurgerea
// cu Tab a coloanelor rândului (inclusiv cele afișate ulterior din Column Chooser).
function onProdusBoxKeyDown(e: any, cellInfo: any) {
    if (e.event.key === 'Enter') {
        e.event.stopPropagation();
        e.event.preventDefault();
        e.component.open();
        return;
    }
    if (e.event.key === 'Tab') {
        e.event.preventDefault();
        const instance = gridRef.value?.instance;
        if (!instance) return;
        const nextField = getAdjacentEditableColumn(instance, 'ProdusID', e.event.shiftKey ? -1 : 1);
        if (nextField) instance.editCell(cellInfo.rowIndex, nextField);
    }
}

function onProdusGridContentReady() {
    if (!shouldFocusFilter) return;
    shouldFocusFilter = false;
    window.setTimeout(() => {
        const el = (innerProdusGridRef.value as any)?.$el as HTMLElement | undefined;
        const input = el?.querySelector<HTMLInputElement>('.dx-datagrid-filter-row .dx-texteditor-input');
        input?.focus();
    }, 0);
}

function onProdusGridKeyDown(e: any, cellInfo: any) {
    if (e.event.key !== 'Enter' && e.event.key !== 'Tab') return;
    // Oprim mereu propagarea unui Enter din interiorul dropdown-ului de produs — altfel,
    // apăsat în rândul de filtru (căutare), scapă către grid-ul principal și poate declanșa
    // salvarea prematură a rândului nou aflat încă în curs de completare (vezi onGridKeyDown).
    e.event.stopPropagation();
    if (e.event.target?.closest?.('.dx-datagrid-filter-row')) return;
    e.event.preventDefault();
    const grid = e.component;
    const focusedRowIndex = grid.option('focusedRowIndex');
    if (focusedRowIndex < 0) return;
    const rowData = grid.getVisibleRows()[focusedRowIndex]?.data;
    if (rowData) onProdusGridSelection({ selectedRowsData: [rowData] }, cellInfo);
}

function onProdusGridSelection(e: any, cellInfo: any) {
    const prod = e.selectedRowsData[0];
    if (!prod) return;
    cellInfo.data.ProdusNume = prod.Nume;
    // Populează navigation property ca gridul să afișeze Cod/CodIntern fără reload
    cellInfo.data.Produs = { Cod: prod.Cod, CodIntern: prod.CodIntern, Nume: prod.Nume, Pret: prod.Pret, PretValuta: prod.PretValuta };

    // prod.Pret == null înseamnă "nesetat"; 0 e o valoare de preț validă (produs gratuit),
    // nu se tratează ca "gol" — se distinge explicit de null.
    const pretLista = prod.Pret;
    const cursLista = prod.PretValuta?.Curs ?? null;
    if (pretLista != null && cursLista != null && cursLista > 0) {
        // Pret Unitar = Pret Lista × curs — Pret Lista rămâne populat pentru referință/Refresh curs
        cellInfo.data.PretLista = pretLista;
        cellInfo.data.PretListaCurs = cursLista;
        cellInfo.data.PretUnitar = Math.round(pretLista * cursLista * 100) / 100;
    } else {
        // Produsul nu are preț de listă în valută — folosim direct prețul de vânzare
        cellInfo.data.PretLista = null;
        cellInfo.data.PretListaCurs = null;
        cellInfo.data.PretUnitar = prod.PretVanzare ?? 0;
    }
    cellInfo.data.PretNegociat = cellInfo.data.PretUnitar;
    if (prod.PretValutaId != null) {
        cellInfo.data.PretListaValutaID = prod.PretValutaId;
        cellInfo.data.FurnizorPretValutaID = prod.PretValutaId;
    }
    // Preț Furnizor inițial = Pret (cost achiziție) dacă există, altfel PretVanzare
    const pretFurnizor = prod.Pret || prod.PretVanzare || null;
    if (pretFurnizor != null) cellInfo.data.FurnizorPret = pretFurnizor;
    const cat = currentCategorie.value;
    // TVA: dacă TvaDinComanda e activ, se folosește TVA-ul categoriei; altfel TVA-ul produsului, cu fallback pe categorie sau 19%
    const catTVA = cat?.TVA ?? null;
    cellInfo.data.TVA = cat?.TvaDinComanda ? (catTVA ?? 19) : (prod.TvaCurent ?? catTVA ?? 19);
    // Garanție: produsul are prioritate, then categorie
    cellInfo.data.GarantieLuni = prod.GarantieLuni ?? cat?.GarantieLuni ?? null;
    cellInfo.setValue(prod.Id);
    // Forțează actualizarea afișajului în DxDropDownBox
    currentDropBoxInstance?.option('value', prod.Id);
    currentDropBoxInstance?.close();
    // Mută focusul pe Cantitate folosind API-ul DevExtreme
    window.setTimeout(() => {
        gridRef.value?.instance?.editCell(cellInfo.rowIndex, 'Cantitate');
    }, 100);
}

// ── Export PDF (Bon Comandă) ──
async function onExportPdf() {
    if (!gridRef.value?.instance) return;
    const doc = new jsPDF('l', 'mm', 'a4');
    const pageW = 297;
    const margin = 10;
    const contentW = pageW - 2 * margin;
    const order = localOrderData.value;
    const valuta = order?.Valuta?.Simbol ?? 'RON';

    // ── Titlu ──────────────────────────────────────────────────────────────
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    doc.text('BON COMANDĂ', margin, 13);

    // Nr. + Data + Stare (aliniate dreapta sus)
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text(`Nr.: ${order?.Cod ?? ''}`, margin + 90, 10);
    doc.text(`Data: ${formatDate(order?.DataComenzii)}`, margin + 90, 15);
    doc.text(`Stare: ${getStareLabel(order?.Stare)}`, margin + 90, 20);

    // ── Separator 1 ────────────────────────────────────────────────────────
    doc.setDrawColor(220, 220, 220);
    doc.line(margin, 23, pageW - margin, 23);

    // ── Info partener / agent ──────────────────────────────────────────────
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text('Client:', margin, 28);
    doc.setFont('helvetica', 'normal');
    doc.text(order?.Client?.Nume ?? '—', margin + 16, 28);
    if (order?.Client?.CUI) {
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(120, 120, 120);
        doc.text(`CUI: ${order.Client.CUI}`, margin + 16, 32);
        doc.setTextColor(0, 0, 0);
    }

    const colRight = margin + contentW / 2;
    doc.setFont('helvetica', 'bold');
    doc.text('Agent:', colRight, 28);
    doc.setFont('helvetica', 'normal');
    doc.text(order?.Agent?.Nume ?? '—', colRight + 14, 28);

    if (order?.TermenLivrare) {
        doc.setFont('helvetica', 'bold');
        doc.text('Termen:', colRight, 32);
        doc.setFont('helvetica', 'normal');
        doc.text(formatDate(order.TermenLivrare), colRight + 17, 32);
    }

    if (order?.Observatii) {
        doc.setFont('helvetica', 'bold');
        doc.text('Obs.:', margin, 36);
        doc.setFont('helvetica', 'normal');
        const obsText = order.Observatii.length > 100 ? order.Observatii.substring(0, 100) + '…' : order.Observatii;
        doc.text(obsText, margin + 12, 36);
    }

    // ── Totaluri ───────────────────────────────────────────────────────────
    const totY = 40;
    doc.setFillColor(248, 249, 252);
    doc.rect(margin, totY - 4, contentW, 7, 'F');
    doc.setDrawColor(220, 220, 220);
    doc.rect(margin, totY - 4, contentW, 7, 'D');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.text(`Val. fără TVA: ${formatMoney(order?.ValoareComanda)} ${valuta}`, margin + 4, totY);
    doc.text(`TVA: ${formatMoney(order?.Tva)} ${valuta}`, margin + contentW * 0.38, totY);
    doc.text(`TOTAL: ${formatMoney(order?.TotalComanda)} ${valuta}`, margin + contentW * 0.63, totY);

    // ── Linii comenzii (DevExtreme grid) ──────────────────────────────────
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);

    await exportDataGrid({
        jsPDFDocument: doc,
        component: gridRef.value.instance,
        topLeft: { x: margin, y: 48 },
        customizeCell({ pdfCell, gridCell }: any) {
            pdfCell.fontSize = 7.5;
            if (gridCell?.rowType === 'header') {
                pdfCell.font = { style: 'bold' };
                pdfCell.backgroundColor = '#f1f5f9';
            }
        },
    });

    doc.save(`Comanda_${order?.Cod ?? 'export'}.pdf`);
}

// ── Rezervări ──
async function onRezervaToate() {
    isRezervandToate.value = true;
    try {
        await ProComenziService.rezervaToate(props.comandaId);
        await Promise.all([refreshCantitatiRezervate(), refreshStocuriProduse(), refreshRezervari()]);
        gridRef.value?.instance?.repaint();
        toast('Cantitățile disponibile au fost rezervate.', 'success', 2500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3500);
    } finally {
        isRezervandToate.value = false;
    }
}

function onOpenRezerveLinie(row: any) {
    rezervaLineId.value = row.ID;
    rezervareLinieProdusNume.value = row.Produs?.Nume || row.ProdusNume || 'Produs';
    rezervareLinieProdusId.value = row.ProdusID ?? '';
    rezervareLinieCantitateMax.value = row.Cantitate ?? 0;
    rezervareLinieCantitate.value = cantitatiRezervate.value[row.ID] ?? 0;
    showRezervareLiniePopup.value = true;
}

function onRezervareLiniePopupShown() {
    rezervareCantitateRef.value?.instance?.focus();
    rezervareCantitateRef.value?.instance?.element()?.querySelector('input')?.select();
}

const rezervareLinieStocDisponibil = computed(() => {
    return stocuriProduse.value[rezervareLinieProdusId.value]?.StocRamas ?? null;
});

async function onConfirmRezerveLinie() {
    showRezervareLiniePopup.value = false;
    try {
        await ProComenziService.rezervaLinie(props.comandaId, rezervaLineId.value, rezervareLinieCantitate.value);
        await Promise.all([refreshCantitatiRezervate(), refreshStocuriProduse(), refreshRezervari()]);
        gridRef.value?.instance?.repaint();
        toast('Rezervarea a fost actualizată.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3500);
    }
}

function formatRezervare(id: string | undefined, cantitate: number | undefined): string {
    if (!id) return '—';
    const rez = cantitatiRezervate.value[id] ?? 0;
    const cant = cantitate ?? 0;
    if (cant === 0) return '—';
    return `${cant} / ${rez}`;
}

function getRezervareClass(id: string | undefined, cantitate: number | undefined): string {
    if (!id) return 'rezervare-none';
    const rez = cantitatiRezervate.value[id] ?? 0;
    const cant = cantitate ?? 0;
    if (cant === 0 || rez === 0) return 'rezervare-none';
    return rez >= cant ? 'rezervare-full' : 'rezervare-partial';
}

// ── Helpers ──
function toast(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', displayTime = 3000) {
    notify({ message, type, displayTime }, { position: 'bottom right', direction: 'up-push' });
}

function getErrMsg(err: any): string {
    if (err?.response?.data) {
        const data = err.response.data;
        if (typeof data === 'string') return data;
        if (data.error?.message) return data.error.message; // OData format
        if (data.message) return data.message; // PermissionFilter (403 acces refuzat)
        if (data.Message) return data.Message; // Classic ASP.NET
        if (data.ExceptionMessage) return data.ExceptionMessage;
        if (data.title) return data.title; // ASP.NET Core ProblemDetails
    }
    return err?.message ?? 'A apărut o eroare.';
}

async function refreshLocalData() {
    if (!props.comandaId) return;
    try {
        const resp = await http.clientComercialOdata.get(
            `PRO_Comenzi(${props.comandaId})?$expand=Agent($select=Nume),Client($select=Nume,CUI),Valuta($select=Simbol),Proiect($select=Cod,Nume)`
        );
        localOrderData.value = resp.data;
    } catch { /* ignore */ }
}

const STARE_COLORS: Record<string, { background: string; color: string }> = {
    'inasteptare': { background: '#f5f3ff', color: '#6d28d9' },
    'confirmata':  { background: '#eff6ff', color: '#1d4ed8' },
    'inlucru':     { background: '#fef3c7', color: '#92400e' },
    'finalizata':  { background: '#ecfdf5', color: '#065f46' },
    'anulata':     { background: '#fef2f2', color: '#991b1b' },
};

const STARE_LABELS: Record<string, string> = {
    'InAsteptare': 'In Asteptare',
    'InLucru':     'In Lucru',
};
function getStareLabel(stare: string | null | undefined): string {
    return STARE_LABELS[stare ?? ''] ?? (stare ?? '');
}

function getStareChipStyle(stare: string): Record<string, string> {
    const key = (stare ?? '').toLowerCase().trim();
    const t = STARE_COLORS[key] ?? { background: '#f1f5f9', color: '#475569' };
    return {
        background: t.background, color: t.color,
        padding: '4px 12px', borderRadius: '20px', fontWeight: '700',
        fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px',
        display: 'inline-block', whiteSpace: 'nowrap',
    };
}

function formatDate(val: string | null | undefined): string {
    if (!val) return '—';
    return new Date(val).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function formatRO(val: number | null | undefined): string {
    if (val == null) return '';
    return val.toLocaleString('ro-RO', { maximumFractionDigits: 10 });
}

function formatMoney(val: number | null | undefined): string {
    if (val == null) return '—';
    return val.toLocaleString('ro-RO', { maximumFractionDigits: 10 });
}

function getProdusNume(rowData: any): string {
    return rowData?.Produs?.Nume || rowData?.ProdusNume || '';
}

function getProdusLookupDisplay(item: any): string {
    if (!item) return '';
    const cod = [item.Cod, item.CodIntern].filter(Boolean).join(' / ');
    return cod ? `${cod} — ${item.Nume ?? ''}` : (item.Nume ?? '');
}

function calcCursLista(row: any): number | null {
    // Afișează mereu ultimul curs BNR din ERP_CursValutar pentru valuta liniei — nu cursul
    // "înghețat" la ultimul calcul (PretListaCurs) și nici ERP_Valute.Curs (poate fi neactualizat).
    const valutaId = row.PretListaValutaID ? String(row.PretListaValutaID).toLowerCase() : null;
    if (valutaId && latestCursuriByValuta.value[valutaId] != null) {
        return latestCursuriByValuta.value[valutaId];
    }
    return row.PretListaCurs ?? row.PretListaValuta?.Curs ?? null;
}


function getPretUnitarDisplay(cellData: any): number | null {
    const changes = (gridRef.value?.instance?.option('editing.changes') ?? []) as any[];
    const rowChange = changes.find(c => c.key === cellData.key);
    if (rowChange?.data?.PretUnitar != null) return rowChange.data.PretUnitar;
    return calcCache.value[cellData.key]?.PretUnitar ?? cellData.data.PretUnitar;
}

function getPretNegociatDisplay(cellData: any): number | null {
    const changes = (gridRef.value?.instance?.option('editing.changes') ?? []) as any[];
    const rowChange = changes.find(c => c.key === cellData.key);
    if (rowChange?.data?.PretNegociat !== undefined) return rowChange.data.PretNegociat;
    return calcCache.value[cellData.key]?.PretNegociat ?? cellData.data.PretNegociat;
}

function calcStocEfectiv(row: any): number | null {
    if (!row.ProdusID) return null;
    return stocuriProduse.value[row.ProdusID]?.StocEfectiv ?? null;
}

function calcStocRezervat(row: any): number | null {
    if (!row.ProdusID) return null;
    return stocuriProduse.value[row.ProdusID]?.StocRezervat ?? null;
}


function calcStocRamas(row: any): number | null {
    if (!row.ProdusID) return null;
    return stocuriProduse.value[row.ProdusID]?.StocRamas ?? null;
}

// ── Eșalonări CRUD ──
function onOpenEsalonari(row: any) {
    if (!row?.ID) return;
    esalonariDetaliuId.value = row.ID;
    esalonariDetaliuNume.value = row.Produs?.Nume ?? row.ProdusNume ?? 'Linie';

    const token = localStorage.getItem('ERA_Jwt') ?? '';
    esalonariStore.value = new DataSource({
        store: {
            type: 'odata',
            url: `${AppSetting.API_Url_ComercialOdata}PRO_ComenziEsalonari?detaliuId=${row.ID}`,
            key: 'Id',
            version: 4,
            beforeSend: (e: any) => {
                e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token };
            },
        },
    });

    showEsalonariPopup.value = true;
}

async function onEsalonareInserting(e: any) {
    const data = { ...e.data };
    e.cancel = true;
    setTimeout(() => esalonariGridRef.value?.instance?.cancelEditData(), 0);

    try {
        await ProComenziService.adaugaEsalonare({
            ComandaDetaliuID: esalonariDetaliuId.value!,
            DataLivrare: data.DataLivrare ?? null,
            Cantitate: data.Cantitate ?? 0,
            CantitateStoc: data.CantitateStoc ?? 0,
            CantitateTotal: data.CantitateTotal ?? data.Cantitate ?? 0,
            Status: data.Status ?? 1,
            CantitateDorita: data.CantitateDorita ?? null,
            CantitateDinNecesar: data.CantitateDinNecesar ?? null,
        });
        esalonariStore.value?.reload();
        toast('Eșalonarea a fost adăugată.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3000);
    }
}

async function onEsalonareUpdating(e: any) {
    const key = e.key;
    const newData = { ...e.newData };
    e.cancel = true;
    setTimeout(() => esalonariGridRef.value?.instance?.cancelEditData(), 0);

    try {
        await ProComenziService.patchEsalonare(key, newData);
        esalonariStore.value?.reload();
        toast('Eșalonarea a fost actualizată.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3000);
    }
}

async function onEsalonareRemoving(e: any) {
    e.cancel = true;
    const ok = await custom({
        title: 'Confirmare ștergere',
        messageHtml: 'Ești sigur că vrei să ștergi această eșalonare?',
        buttons: [
            { text: 'Da', type: 'danger', onClick: () => true },
            { text: 'Nu', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    try {
        await ProComenziService.stergeEsalonare(e.key);
        esalonariStore.value?.reload();
        toast('Eșalonarea a fost ștearsă.', 'success', 1500);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 3000);
    }
}

// ── Column chooser: închide la click în afară ──
function handleColumnChooserOutsideClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (
        !target.closest('.dx-datagrid-column-chooser') &&
        !target.closest('[data-name="columnChooserButton"]') &&
        !target.closest('.dx-column-chooser-button')
    ) {
        gridRef.value?.instance?.hideColumnChooser?.();
    }
}

// ── Salvare automată la ieșirea focusului din grid — pattern DevExtreme pentru batch mode.
// NU ne bazăm pe relatedTarget-ul evenimentului "focusout" (nesigur — multe butoane
// DevExtreme fac preventDefault() pe mousedown, deci relatedTarget poate fi null) și NICI
// pe instance.element() (referință posibil capturată prea devreme, înainte ca toolbar-ul
// să fie complet randat). Verificăm în schimb, după un delay, document.activeElement cu
// closest('.detalii-grid') — selector CSS, robust indiferent de referința instanței —
// și dăm suficient timp propriilor setTimeout-uri interne DevExtreme (ex. addRow() la
// click pe "Adaugă produs în comandă") să-și termine mutarea focusului înainte să verificăm.
function onGridFocusOut() {
    if (isSalvandTot.value) return;
    const instance = gridRef.value?.instance;
    if (!instance) return;

    setTimeout(() => {
        // Navigarea între tab-uri e gestionată explicit de PRO_ComenziView
        // (confirmSwitchAway — dialog Salvează/Renunță/Rămân) — dacă e activă verificarea
        // aia, nu salvăm silențios aici, altfel dialogul nu mai apucă să apară. Pentru
        // orice alt click în afara grid-ului (butoane, restul paginii), auto-salvarea
        // rămâne activă normal.
        if (props.suppressAutoSave) return;

        const changes = (instance.option('editing.changes') ?? []) as any[];
        if (changes.length === 0) return;

        const active = document.activeElement as HTMLElement | null;
        if (active?.closest('.detalii-grid')) return;
        if (active?.closest('.dx-overlay-wrapper')) return;
        onSalveazaTot();
    }, 150);
}

// ── Init ──
onMounted(async () => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('mousedown', handleColumnChooserOutsideClick);
    initEditHeaderDataSources();

    try {
        const [catResp, drepturiResp] = await Promise.all([
            ProComenziService.getCategoriiPermise(),
            ProComenziService.getDrepturiMele(),
        ]);
        categoriiComenzi.value = catResp.data ?? [];
        if (drepturiResp.data) drepturi.value = { ...drepturi.value, ...drepturiResp.data };
    } catch { /* ignore */ }

    loadCursuriValutare();
    loadLatestCursuriToateValutele();
});

onUnmounted(async () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    document.removeEventListener('mousedown', handleColumnChooserOutsideClick);
    (gridRef.value?.instance?.element() as HTMLElement | undefined)?.removeEventListener('focusout', onGridFocusOut);
    if (connectedOrderId) await disconnectSignalR(connectedOrderId);
});

watch(() => props.orderData, (data) => {
    if (data && (!localOrderData.value || localOrderData.value.Id !== data.Id)) {
        localOrderData.value = { ...data };
    }
}, { immediate: true });

watch(() => props.comandaId, (id) => {
    if (!id) return;
    syncSignalRConnection(id).catch(() => {});
    isLoading.value = true;
    const token = localStorage.getItem('ERA_Jwt');
    if (!token) { isLoading.value = false; return; }

    detaliiStore.value = new DataSource({
        store: {
            type: 'odata',
            url: `${AppSetting.API_Url_ComercialOdata}PRO_ComenziDetalii?comandaId=${id}`,
            key: 'ID',
            keyType: 'Guid',
            version: 4,
            beforeSend: (e: any) => {
                e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token };
                e.params.$expand = 'Produs($select=Cod,Nume,CodIntern,Pret,Stocabil;$expand=PretValuta($select=Curs)),Furnizor($select=Nume),FurnizorPretValuta($select=Simbol),PretListaValuta($select=Curs,Simbol),Document($select=Numar;$expand=Tip($select=Cod,Nume)),ClasificatieBugetara($select=Cod,Denumire)';
            },
        },
        sort: [{ selector: 'NrCrt', desc: false }],
    });

    detaliiStore.value.load()
        .then(() => { isLoading.value = false; })
        .catch(() => { isLoading.value = false; });

    refreshLocalData();
    refreshCantitatiRezervate();
    refreshStocuriProduse();
    refreshRezervari();
    refreshAvize();
    refreshReceptii();
    refreshFacturi();
    refreshComenziStorno();
}, { immediate: true });

const hasAutoOpenedRow = ref(false);

function onSelectionChanged(e: any) {
    liniiSelectate.value = (e.selectedRowKeys ?? []) as string[];
}

// Apelat din butonul "Refresh curs" — previzualizează câte produse ar avea Pret Unitar
// modificat (inclusiv cele ajustate manual) și cere confirmare înainte de a aplica efectiv.
async function onRefreshCursClick() {
    if (isRefreshingCurs.value) return;
    isRefreshingCurs.value = true;
    try {
        const preview = await ProComenziService.previewRefreshCurs(props.comandaId);
        const total = preview.data?.TotalModificate ?? 0;
        if (total === 0) {
            toast('Niciun preț unitar nu ar fi modificat — curs deja actualizat.', 'info', 3000);
            return;
        }
        const ok = await custom({
            title: 'Confirmare Refresh Curs',
            messageHtml: `<div style="padding:4px 0">Prețul unitar va fi modificat la <b>${total}</b> produs(e) (inclusiv cele ajustate manual).<br>Continui cu refresh curs?</div>`,
            buttons: [
                { text: 'Da', type: 'default', onClick: () => true },
                { text: 'Nu', stylingMode: 'outlined', onClick: () => false },
            ],
        }).show();
        if (!ok) return;
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
        return;
    } finally {
        isRefreshingCurs.value = false;
    }
    await onRefreshCurs();
}

async function onRefreshCurs() {
    if (isRefreshingCurs.value) return;
    isRefreshingCurs.value = true;
    try {
        const instance = gridRef.value?.instance;
        instance?.cancelEditData();
        await ProComenziService.refreshCurs(props.comandaId);
        calcCache.value = {};
        await detaliiStore.value?.reload();
        await refreshLocalData();
        await Promise.all([loadCursuriValutare(), loadLatestCursuriToateValutele()]);
        instance?.repaint();
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    } finally {
        isRefreshingCurs.value = false;
    }
}

async function onOpenDenumiriPersonalizate(rowData: any) {
    const clientId = localOrderData.value?.ClientId;
    if (!clientId) {
        toast('Comanda nu are un partener selectat.', 'warning', 3000);
        return;
    }
    if (!rowData?.ProdusID) return;

    const produsId: string = rowData.ProdusID;
    const produsNume: string = rowData.ProdusNume ?? rowData.Produs?.Nume ?? '';
    const produsCod: string = rowData.Produs?.Cod ?? '';
    denumiriProdusNume.value = produsNume;
    showDenumiriPopup.value = true;

    try {
        const resp = await ProComenziService.getDenumiriProduse(clientId);
        const existente: any[] = resp.data?.value ?? [];
        const ex = existente.find((d: any) => d.ProdusID === produsId) ?? null;
        const partenerNume = localOrderData.value?.Client?.Nume ?? '';

        denumiriRows.value = [{
            ProdusID: produsId,
            ProdusNume: produsNume,
            ProdusCod: produsCod,
            PartenerNume: partenerNume,
            Cod: ex?.Cod ?? '',
            Nume: ex?.Nume ?? '',
            _existentId: ex?.Id ?? null,
            _originalCod: ex?.Cod ?? '',
            _originalNume: ex?.Nume ?? '',
        }];

        await nextTick();
        setTimeout(() => denumiriGridRef.value?.instance?.editRow(0), 100);
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    }
}

async function onSaveDenumiri() {
    if (isSavingDenumiri.value) return;
    const clientId = localOrderData.value?.ClientId;
    if (!clientId) return;

    await denumiriGridRef.value?.instance?.saveEditData();
    isSavingDenumiri.value = true;
    let salvate = 0;
    let erori = 0;

    for (const row of denumiriRows.value) {
        const hasChanged = row.Cod !== row._originalCod || row.Nume !== row._originalNume;
        if (!hasChanged) continue;

        const codTrim = (row.Cod ?? '').trim();
        const numeTrim = (row.Nume ?? '').trim();

        try {
            if (row._existentId) {
                if (!codTrim && !numeTrim) {
                    // Both cleared → delete
                    await ProComenziService.deleteDenumire(row._existentId);
                    row._existentId = null;
                } else {
                    await ProComenziService.updateDenumire(row._existentId, { Cod: codTrim, Nume: numeTrim });
                }
            } else if (codTrim || numeTrim) {
                const resp = await ProComenziService.saveDenumire({
                    PartenerID: clientId,
                    ProdusID: row.ProdusID,
                    Cod: codTrim,
                    Nume: numeTrim,
                });
                row._existentId = resp.data?.Id ?? null;
            }
            row._originalCod = codTrim;
            row._originalNume = numeTrim;
            salvate++;
        } catch {
            erori++;
        }
    }

    isSavingDenumiri.value = false;

    if (erori > 0) {
        toast(`Salvare parțială: ${salvate} OK, ${erori} erori.`, 'warning', 4000);
    } else {
        if (salvate > 0) toast('Denumire salvată.', 'success', 2000);
        showDenumiriPopup.value = false;
    }
}

async function onGenereazaStornoPartial() {
    if (isGenerandStorno.value || liniiSelectate.value.length === 0) return;
    const ok = await custom({
        title: 'Generare storno parțial',
        messageHtml: `<div style="padding:4px 0">Se generează storno pentru <b>${liniiSelectate.value.length} linie(i) selectate</b>.<br>Comanda storno va fi creată cu starea <b>Confirmată</b>.<br><br>Continui?</div>`,
        buttons: [
            { text: 'Da, generează', type: 'default', onClick: () => true },
            { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    isGenerandStorno.value = true;
    try {
        const resp = await ProComenziService.genereazaStorno(props.comandaId, liniiSelectate.value);
        const storno = resp.data;
        gridRef.value?.instance?.clearSelection();
        toast(`Comandă storno generată: ${storno?.Cod ?? ''}`, 'success', 3000);
        await refreshComenziStorno();
    } catch (err: any) {
        toast(getErrMsg(err), 'error', 4000);
    } finally {
        isGenerandStorno.value = false;
    }
}

function onGridContentReady() {
    liniiGrid.value = gridRef.value?.instance?.getDataSource().items() ?? [];
    if (!props.isNew || hasAutoOpenedRow.value) return;
    // content-ready se declanșează și ÎNAINTE ca încărcarea reală (detaliiStore.load()) să se
    // termine — la acel moment items() e mereu gol, indiferent dacă comanda are deja linii.
    // Fără gărzile de mai jos, redeschiderea unei comenzi "isNew" care ARE deja un produs ar
    // adăuga automat un rând nou gol, care ajunge vizibil lângă produsul real după încărcare
    // (apărea ca "produsul apare de două ori", inconsistent, în funcție de viteza răspunsului).
    if (isLoading.value || liniiGrid.value.length > 0) return;
    hasAutoOpenedRow.value = true;
    gridRef.value?.instance?.addRow();
}

// ── Apelabile din PRO_ComenziView, ÎNAINTE de a schimba tab-ul (deci înainte ca v-if
// să demonteze această comandă) — o dată demontată, editing.changes din DevExtreme
// se pierde ireversibil, deci verificarea/salvarea trebuie făcută cât timp componenta
// e încă montată, nu reactiv după aceea.
async function trySaveBeforeLeave(): Promise<{ ok: boolean }> {
    const instance = gridRef.value?.instance;
    if (!instance) return { ok: true };

    const changes = (instance.option('editing.changes') ?? []) as any[];
    if (changes.length === 0) return { ok: true };

    await onSalveazaTot();

    const remaining = (instance.option('editing.changes') ?? []) as any[];
    return { ok: remaining.length === 0 };
}

function discardUnsavedLine() {
    gridRef.value?.instance?.cancelEditData();
}

// Verificare rapidă, fără să încerce salvarea — folosită de PRO_ComenziView ca să decidă
// dacă arată dialogul de confirmare înainte de a schimba tab-ul.
function hasPendingChanges(): boolean {
    const changes = (gridRef.value?.instance?.option('editing.changes') ?? []) as any[];
    return changes.length > 0;
}

__expose({ hasUnsavedChanges, trySaveBeforeLeave, discardUnsavedLine, hasPendingChanges });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["detalii-wrapper", { 'detalii-fullscreen': isFullscreen.value }])
    }, [
      (localOrderData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[56] || (_cache[56] = _createElementVNode("i", { class: "dx-icon dx-icon-doc header-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(localOrderData.value.Cod), 1)
                ]),
                (localOrderData.value.Proiect?.Cod)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(localOrderData.value.Proiect.Cod), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "stare-chip",
                  style: _normalizeStyle(getStareChipStyle(localOrderData.value.Stare))
                }, _toDisplayString(getStareLabel(localOrderData.value.Stare)), 5),
                (localOrderData.value.Facturat)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Facturat"))
                  : _createCommentVNode("", true),
                (localOrderData.value.LivrareDirectaFurnizor)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Livrare directă furnizor"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleStateButtons.value, (btn) => {
                  return (_openBlock(), _createBlock(_unref(DxButton), {
                    key: btn.stareNoua,
                    text: btn.text,
                    type: btn.type,
                    hint: btn.disabledHint,
                    "styling-mode": "outlined",
                    disabled: editingByUser.value !== null || btn.disabled,
                    onClick: ($event: any) => (onStateButtonClick(btn))
                  }, null, 8, ["text", "type", "hint", "disabled", "onClick"]))
                }), 128)),
                (!isReadOnly.value && drepturi.value.EditeazaComenzi)
                  ? (_openBlock(), _createBlock(_unref(DxButton), {
                      key: 0,
                      text: "Editează comandă",
                      icon: "edit",
                      "styling-mode": "text",
                      disabled: editingByUser.value !== null || localOrderData.value?.Stare === 'InLucru',
                      onClick: onEditHeader
                    }, null, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "meta-item meta-item--partener",
                onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showMetaTooltip($event, 'Partener', [localOrderData.value.Client?.Nume, localOrderData.value.Client?.CUI].filter(Boolean).join('\n')))),
                onMouseleave: hideMetaTooltip
              }, [
                _cache[58] || (_cache[58] = _createElementVNode("i", { class: "dx-icon dx-icon-group meta-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[57] || (_cache[57] = _createElementVNode("span", { class: "meta-label" }, "Partener", -1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(localOrderData.value.Client?.Nume || '—'), 1),
                  (localOrderData.value.Client?.CUI)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(localOrderData.value.Client.CUI), 1))
                    : _createCommentVNode("", true)
                ])
              ], 32),
              _cache[80] || (_cache[80] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_14, [
                _cache[60] || (_cache[60] = _createElementVNode("i", { class: "dx-icon dx-icon-event meta-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_15, [
                  _cache[59] || (_cache[59] = _createElementVNode("span", { class: "meta-label" }, "Data", -1)),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(formatDate(localOrderData.value.DataComenzii)), 1)
                ])
              ]),
              (localOrderData.value.TermenLivrare)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[62] || (_cache[62] = _createElementVNode("i", { class: "dx-icon dx-icon-clock meta-icon" }, null, -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[61] || (_cache[61] = _createElementVNode("span", { class: "meta-label" }, "Termen Livrare", -1)),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(formatDate(localOrderData.value.TermenLivrare)), 1)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (localOrderData.value.Agent?.Nume)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[66] || (_cache[66] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[65] || (_cache[65] = _createElementVNode("i", { class: "dx-icon dx-icon-user meta-icon" }, null, -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[64] || (_cache[64] = _createElementVNode("span", { class: "meta-label" }, "Agent", -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(localOrderData.value.Agent?.Nume), 1)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (localOrderData.value.Observatii)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[69] || (_cache[69] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
                    _createElementVNode("div", {
                      class: "meta-item meta-item--obs",
                      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (showMetaTooltip($event, 'Observații', localOrderData.value.Observatii))),
                      onMouseleave: hideMetaTooltip
                    }, [
                      _cache[68] || (_cache[68] = _createElementVNode("i", { class: "dx-icon dx-icon-comment meta-icon" }, null, -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[67] || (_cache[67] = _createElementVNode("span", { class: "meta-label" }, "Observații", -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(localOrderData.value.Observatii), 1)
                      ])
                    ], 32)
                  ], 64))
                : _createCommentVNode("", true),
              (tipComandaNume.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _cache[72] || (_cache[72] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[71] || (_cache[71] = _createElementVNode("i", { class: "dx-icon dx-icon-tags meta-icon" }, null, -1)),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[70] || (_cache[70] = _createElementVNode("span", { class: "meta-label" }, "Tip comandă", -1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(tipComandaNume.value), 1)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _cache[81] || (_cache[81] = _createElementVNode("div", { class: "meta-spacer" }, null, -1)),
              _createElementVNode("div", _hoisted_28, [
                (cursEUR.value !== null || cursUSD.value !== null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_29, [
                        _cache[75] || (_cache[75] = _createElementVNode("span", { class: "meta-label" }, "Cursuri BNR", -1)),
                        _createElementVNode("div", _hoisted_30, [
                          (cursEUR.value !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _cache[73] || (_cache[73] = _createElementVNode("span", { class: "curs-simbol" }, "EUR", -1)),
                                _createElementVNode("span", _hoisted_32, _toDisplayString(formatRO(cursEUR.value)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (cursUSD.value !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _cache[74] || (_cache[74] = _createElementVNode("span", { class: "curs-simbol" }, "USD", -1)),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(formatRO(cursUSD.value)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[76] || (_cache[76] = _createElementVNode("div", {
                        class: "meta-divider",
                        style: {"margin":"0 10px"}
                      }, null, -1))
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[77] || (_cache[77] = _createElementVNode("span", { class: "totals-label" }, "Fără TVA", -1)),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(formatMoney(localOrderData.value.ValoareComanda)) + " " + _toDisplayString(localOrderData.value.Valuta?.Simbol || ''), 1)
                  ]),
                  _cache[79] || (_cache[79] = _createElementVNode("div", { class: "totals-separator" }, null, -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[78] || (_cache[78] = _createElementVNode("span", { class: "totals-label totals-label--main" }, [
                      _createElementVNode("i", {
                        class: "dx-icon dx-icon-money",
                        style: {"font-size":"11px","vertical-align":"middle","margin-right":"3px"}
                      }),
                      _createTextVNode(" Total cu TVA ")
                    ], -1)),
                    _createElementVNode("span", _hoisted_39, _toDisplayString(formatMoney(localOrderData.value.TotalComanda)) + " " + _toDisplayString(localOrderData.value.Valuta?.Simbol || ''), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!isFullscreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              (localOrderData.value && documentsGenerate.value.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(["docs-tab-chip", { active: activeDocTab.value === 'docgen' }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleDocTab('docgen')))
                  }, [
                    _cache[82] || (_cache[82] = _createElementVNode("i", { class: "dx-icon dx-icon-doc" }, null, -1)),
                    _cache[83] || (_cache[83] = _createElementVNode("span", null, "Documente", -1)),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(documentsGenerate.value.length), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (localOrderData.value && (rezervari.value.length > 0 || currentCategorie.value?.RezervareDocID))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: _normalizeClass(["docs-tab-chip", { active: activeDocTab.value === 'rezervari' }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleDocTab('rezervari')))
                  }, [
                    _cache[84] || (_cache[84] = _createElementVNode("i", { class: "dx-icon dx-icon-clock" }, null, -1)),
                    _cache[85] || (_cache[85] = _createElementVNode("span", null, "Rezervări", -1)),
                    (rezervari.value.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(rezervari.value.length), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (localOrderData.value && (avize.value.length > 0 || ['InLucru','Finalizata'].includes(localOrderData.value.Stare ?? '')))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: _normalizeClass(["docs-tab-chip", { active: activeDocTab.value === 'avize' }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleDocTab('avize')))
                  }, [
                    _cache[86] || (_cache[86] = _createElementVNode("i", { class: "dx-icon dx-icon-export" }, null, -1)),
                    _cache[87] || (_cache[87] = _createElementVNode("span", null, "Avize", -1)),
                    (avize.value.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(avize.value.length), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (localOrderData.value && isClientOrder.value && (facturi.value.length > 0 || ['InLucru','Finalizata'].includes(localOrderData.value.Stare ?? '')))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: _normalizeClass(["docs-tab-chip", { active: activeDocTab.value === 'facturi' }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleDocTab('facturi')))
                  }, [
                    _cache[88] || (_cache[88] = _createElementVNode("i", { class: "dx-icon dx-icon-money" }, null, -1)),
                    _cache[89] || (_cache[89] = _createElementVNode("span", null, "Facturi", -1)),
                    (facturi.value.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(facturi.value.length), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (localOrderData.value && (receptii.value.length > 0 || (!isClientOrder.value && ['Confirmata','InLucru'].includes(localOrderData.value.Stare ?? ''))))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: _normalizeClass(["docs-tab-chip", { active: activeDocTab.value === 'receptii' }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleDocTab('receptii')))
                  }, [
                    _cache[90] || (_cache[90] = _createElementVNode("i", { class: "dx-icon dx-icon-import" }, null, -1)),
                    _cache[91] || (_cache[91] = _createElementVNode("span", null, "Recepții", -1)),
                    (receptii.value.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(receptii.value.length), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (localOrderData.value && comenziStorno.value.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    class: _normalizeClass(["docs-tab-chip", { active: activeDocTab.value === 'storno' }]),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleDocTab('storno')))
                  }, [
                    _cache[92] || (_cache[92] = _createElementVNode("i", { class: "dx-icon dx-icon-revert" }, null, -1)),
                    _cache[93] || (_cache[93] = _createElementVNode("span", null, "Storno", -1)),
                    _createElementVNode("span", _hoisted_47, _toDisplayString(comenziStorno.value.length), 1)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_48, [
                (drepturi.value.ReceptioneazaMarfa && localOrderData.value && !isClientOrder.value && ['Confirmata','InLucru'].includes(localOrderData.value.Stare ?? ''))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode(_unref(DxButton), {
                        text: "Recepționează",
                        icon: "plus",
                        type: "default",
                        "styling-mode": "outlined",
                        size: "small",
                        disabled: editingByUser.value !== null || isGenereazaReceptie.value,
                        onClick: onOpenReceptiePopup
                      }, null, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (activeDocTab.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  (activeDocTab.value === 'docgen')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": documentsGenerate.value,
                          "key-expr": "DocumentID",
                          "show-borders": false,
                          "show-column-lines": false,
                          "show-row-lines": true,
                          "allow-column-resizing": true,
                          "column-resizing-mode": 'widget',
                          "hover-state-enabled": true,
                          "row-alternation-enabled": true,
                          class: "docs-panel-grid"
                        }, {
                          actiuniDocTemplate: _withCtx(({ data }) => [
                            _createVNode(_unref(DxButton), {
                              icon: "eyeopen",
                              "styling-mode": "text",
                              hint: "Deschide document",
                              onClick: ($event: any) => (onOpenDocument(data.data))
                            }, null, 8, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(DxColumn), {
                              caption: "",
                              width: 50,
                              fixed: true,
                              "fixed-position": "left",
                              "allow-sorting": false,
                              "allow-resizing": false,
                              "cell-template": "actiuniDocTemplate"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "TipCod",
                              caption: "Tip",
                              width: 80,
                              "allow-resizing": true
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "TipNume",
                              caption: "Denumire tip",
                              "allow-resizing": true
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Numar",
                              caption: "Număr",
                              width: 140,
                              "allow-resizing": true
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]))
                    : _createCommentVNode("", true),
                  (activeDocTab.value === 'rezervari')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": rezervari.value,
                          "key-expr": "Id",
                          "show-borders": false,
                          "show-column-lines": false,
                          "show-row-lines": true,
                          "hover-state-enabled": true,
                          "row-alternation-enabled": true,
                          class: "docs-panel-grid"
                        }, {
                          stareRezervareTemplate: _withCtx(({ data }) => [
                            (data.data.Anulat)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Anulată"))
                              : _createCommentVNode("", true)
                          ]),
                          deschideRezervareTemplate: _withCtx(({ data }) => [
                            _createVNode(_unref(DxButton), {
                              icon: "eyeopen",
                              "styling-mode": "text",
                              hint: "Deschide documentul",
                              onClick: ($event: any) => (onOpenDocument({ DocumentID: data.data.Id }))
                            }, null, 8, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Tip.Nume",
                              caption: "Tip"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Numar",
                              caption: "Număr",
                              width: 140
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Data",
                              caption: "Data",
                              "data-type": "date",
                              format: "dd.MM.yyyy",
                              width: 110,
                              alignment: "center"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "Anulat",
                              width: 100,
                              alignment: "center",
                              "allow-sorting": false,
                              "cell-template": "stareRezervareTemplate"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "",
                              width: 60,
                              "allow-sorting": false,
                              "cell-template": "deschideRezervareTemplate"
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]))
                    : _createCommentVNode("", true),
                  (activeDocTab.value === 'avize')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": avize.value,
                          "key-expr": "Id",
                          "show-borders": false,
                          "show-column-lines": false,
                          "show-row-lines": true,
                          "hover-state-enabled": true,
                          "row-alternation-enabled": true,
                          class: "docs-panel-grid"
                        }, {
                          stareAvizTemplate: _withCtx(({ data }) => [
                            (data.data.Anulat)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Anulat"))
                              : _createCommentVNode("", true)
                          ]),
                          actiuniAvizTemplate: _withCtx(({ data }) => [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_unref(DxButton), {
                                icon: "eyeopen",
                                "styling-mode": "text",
                                hint: "Deschide documentul (cu liniile comenzii)",
                                onClick: ($event: any) => (onOpenDocument({ DocumentID: data.data.Id }))
                              }, null, 8, ["onClick"]),
                              _createVNode(_unref(DxButton), {
                                icon: "print",
                                "styling-mode": "text",
                                hint: "Tipărește aviz",
                                onClick: ($event: any) => (onTiparesteAviz(data.data))
                              }, null, 8, ["onClick"]),
                              _createVNode(_unref(DxButton), {
                                icon: "remove",
                                "styling-mode": "text",
                                hint: !drepturi.value.AnuleazaAvize ? 'Nu aveți dreptul de a anula avize.' : 'Anulează aviz',
                                type: "danger",
                                disabled: data.data.Anulat || !drepturi.value.AnuleazaAvize,
                                onClick: ($event: any) => (onAnuleazaAviz(data.data))
                              }, null, 8, ["hint", "disabled", "onClick"])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Tip.Nume",
                              caption: "Tip"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Numar",
                              caption: "Număr",
                              width: 140
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Data",
                              caption: "Data",
                              "data-type": "date",
                              format: "dd.MM.yyyy",
                              width: 110,
                              alignment: "center"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "ExpediereNume",
                              caption: "Delegat"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "ExpediereMijloc",
                              caption: "Mijloc transport"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Observatii",
                              caption: "Observații"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "Stare",
                              width: 90,
                              alignment: "center",
                              "allow-sorting": false,
                              "cell-template": "stareAvizTemplate"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "",
                              width: 120,
                              "allow-sorting": false,
                              "cell-template": "actiuniAvizTemplate"
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]))
                    : _createCommentVNode("", true),
                  (activeDocTab.value === 'facturi')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": facturi.value,
                          "key-expr": "Id",
                          "show-borders": false,
                          "show-column-lines": false,
                          "show-row-lines": true,
                          "hover-state-enabled": true,
                          "row-alternation-enabled": true,
                          class: "docs-panel-grid"
                        }, {
                          stareFacturaTemplate: _withCtx(({ data }) => [
                            (data.data.Anulat)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Anulată"))
                              : (data.data.StornatRetur)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Stornată"))
                                : _createCommentVNode("", true)
                          ]),
                          actiuniFacturaTemplate: _withCtx(({ data }) => [
                            _createElementVNode("div", _hoisted_59, [
                              _createVNode(_unref(DxButton), {
                                icon: "eyeopen",
                                "styling-mode": "text",
                                hint: "Deschide documentul (cu liniile comenzii)",
                                onClick: ($event: any) => (onOpenDocument({ DocumentID: data.data.Id }))
                              }, null, 8, ["onClick"]),
                              _createVNode(_unref(DxButton), {
                                icon: "print",
                                "styling-mode": "text",
                                hint: "Tipărește factură",
                                onClick: ($event: any) => (onTiparesteFactura(data.data))
                              }, null, 8, ["onClick"]),
                              _createVNode(_unref(DxButton), {
                                icon: "checkmarkcircle",
                                "styling-mode": "text",
                                hint: "Tipărește certificat de garanție",
                                onClick: ($event: any) => (onTipareasteCertificatGarantie(data.data))
                              }, null, 8, ["onClick"]),
                              (drepturi.value.GenereazaFacturi)
                                ? (_openBlock(), _createBlock(_unref(DxButton), {
                                    key: 0,
                                    icon: "minus",
                                    "styling-mode": "text",
                                    hint: "Stornează factură",
                                    type: "danger",
                                    disabled: data.data.StornatRetur || data.data.Anulat,
                                    onClick: ($event: any) => (onStorneazaFactura(data.data))
                                  }, null, 8, ["disabled", "onClick"]))
                                : _createCommentVNode("", true),
                              (drepturi.value.AnuleazaFacturi)
                                ? (_openBlock(), _createBlock(_unref(DxButton), {
                                    key: 1,
                                    icon: "close",
                                    "styling-mode": "text",
                                    hint: "Anulează factură (fără document de corecție)",
                                    type: "danger",
                                    disabled: data.data.StornatRetur || data.data.Anulat,
                                    onClick: ($event: any) => (onAnuleazaFactura(data.data))
                                  }, null, 8, ["disabled", "onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Tip.Nume",
                              caption: "Tip"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Numar",
                              caption: "Număr",
                              width: 140
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Data",
                              caption: "Data",
                              "data-type": "date",
                              format: "dd.MM.yyyy",
                              width: 110,
                              alignment: "center"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Scadenta",
                              caption: "Scadență",
                              "data-type": "date",
                              format: "dd.MM.yyyy",
                              width: 110,
                              alignment: "center"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Valoare",
                              caption: "Val. fără TVA",
                              "data-type": "number",
                              format: formatRO,
                              width: 140,
                              alignment: "right"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Total",
                              caption: "Total",
                              "data-type": "number",
                              format: formatRO,
                              width: 120,
                              alignment: "right"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Observatii",
                              caption: "Observații"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "Stare",
                              width: 100,
                              alignment: "center",
                              "allow-sorting": false,
                              "cell-template": "stareFacturaTemplate"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "",
                              width: 150,
                              "allow-sorting": false,
                              "cell-template": "actiuniFacturaTemplate"
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]))
                    : _createCommentVNode("", true),
                  (activeDocTab.value === 'receptii')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": receptii.value,
                          "key-expr": "Id",
                          "show-borders": false,
                          "show-column-lines": false,
                          "show-row-lines": true,
                          "hover-state-enabled": true,
                          "row-alternation-enabled": true,
                          class: "docs-panel-grid"
                        }, {
                          printNirTemplate: _withCtx(({ data }) => [
                            _createElementVNode("div", _hoisted_61, [
                              _createVNode(_unref(DxButton), {
                                icon: "eyeopen",
                                "styling-mode": "text",
                                hint: "Deschide documentul (cu liniile comenzii)",
                                onClick: ($event: any) => (onOpenDocument({ DocumentID: data.data.Id }))
                              }, null, 8, ["onClick"]),
                              _createVNode(_unref(DxButton), {
                                icon: "print",
                                "styling-mode": "text",
                                hint: "Tipărește NIR",
                                onClick: ($event: any) => (onTiparesteNir(data.data))
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Numar",
                              caption: "Nr. NIR",
                              width: 130
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Data",
                              caption: "Data",
                              "data-type": "date",
                              format: "dd.MM.yyyy",
                              width: 110,
                              alignment: "center"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Valoare",
                              caption: "Val. fără TVA",
                              "data-type": "number",
                              format: formatRO,
                              width: 140,
                              alignment: "right"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Total",
                              caption: "Total",
                              "data-type": "number",
                              format: formatRO,
                              width: 120,
                              alignment: "right"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Observatii",
                              caption: "Observații"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "",
                              width: 80,
                              "allow-sorting": false,
                              "cell-template": "printNirTemplate"
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]))
                    : _createCommentVNode("", true),
                  (activeDocTab.value === 'storno')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": comenziStorno.value,
                          "key-expr": "Id",
                          "show-borders": false,
                          "show-column-lines": false,
                          "show-row-lines": true,
                          "hover-state-enabled": true,
                          "row-alternation-enabled": true,
                          class: "docs-panel-grid"
                        }, {
                          stareStornoTemplate: _withCtx(({ data }) => [
                            _createElementVNode("span", {
                              class: "stare-chip",
                              style: _normalizeStyle(getStareChipStyle(data.value))
                            }, _toDisplayString(getStareLabel(data.value)), 5)
                          ]),
                          totalStornoTemplate: _withCtx(({ data }) => [
                            _createElementVNode("span", _hoisted_63, _toDisplayString(formatMoney(data.value)), 1)
                          ]),
                          deschideStornoTemplate: _withCtx(({ data }) => [
                            _createVNode(_unref(DxButton), {
                              icon: "eyeopen",
                              "styling-mode": "text",
                              hint: "Deschide comanda storno",
                              onClick: ($event: any) => (emit('open-order', data.data))
                            }, null, 8, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Cod",
                              caption: "Cod",
                              width: 140
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "DataComenzii",
                              caption: "Data",
                              "data-type": "date",
                              format: "dd.MM.yyyy",
                              width: 110,
                              alignment: "center"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "Stare",
                              caption: "Stare",
                              width: 120,
                              "cell-template": "stareStornoTemplate"
                            }),
                            _createVNode(_unref(DxColumn), {
                              "data-field": "TotalComanda",
                              caption: "Total",
                              "data-type": "number",
                              format: formatRO,
                              width: 130,
                              alignment: "right",
                              "cell-template": "totalStornoTemplate"
                            }),
                            _createVNode(_unref(DxColumn), {
                              caption: "",
                              width: 60,
                              "allow-sorting": false,
                              "cell-template": "deschideStornoTemplate"
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (editingByUser.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _cache[95] || (_cache[95] = _createElementVNode("i", { class: "dx-icon dx-icon-warning editing-banner-icon" }, null, -1)),
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(editingByUser.value), 1),
              _cache[94] || (_cache[94] = _createTextVNode(" editează această comandă în acest moment.", -1))
            ])
          ]))
        : (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [...(_cache[96] || (_cache[96] = [
              _createElementVNode("span", { class: "loading-text" }, "Se încarcă...", -1)
            ]))]))
          : _createCommentVNode("", true),
      _createVNode(_unref(DxLoadPanel), {
        visible: _unref(isPrinting),
        message: "Se generează PDF-ul...",
        "show-overlay": true,
        "show-pane": true
      }, null, 8, ["visible"]),
      _createVNode(_unref(DxDataGrid), {
        ref_key: "gridRef",
        ref: gridRef,
        "data-source": detaliiStore.value,
        "key-expr": "ID",
        "show-borders": "",
        "column-auto-width": false,
        "allow-column-resizing": true,
        "column-resizing-mode": 'nextColumn',
        "allow-column-reordering": true,
        "focused-row-enabled": true,
        "show-column-lines": true,
        "show-row-lines": true,
        "column-chooser": { enabled: true, mode: 'select', allowSearch: true },
        "filter-row": { visible: true },
        paging: { enabled: false },
        pager: { visible: false },
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        height: "100%",
        class: "detalii-grid",
        onRowInserting: onRowInserting,
        onRowUpdating: onRowUpdating,
        onRowRemoving: onRowRemoving,
        onKeyDown: onGridKeyDown,
        onContentReady: onGridContentReady,
        onSelectionChanged: onSelectionChanged,
        onEditorPreparing: onEditorPreparing,
        onContextMenuPreparing: onDetaliiContextMenuPreparing,
        onInitialized: onGridInitialized,
        onCellPrepared: onDetaliiCellPrepared
      }, {
        fullscreenBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            icon: isFullscreen.value ? 'collapse' : 'expand',
            "styling-mode": "text",
            hint: isFullscreen.value ? 'Ieși din ecran complet' : 'Ecran complet',
            onClick: toggleFullscreen
          }, null, 8, ["icon", "hint"])
        ]),
        adaugaProdusBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: "Adaugă produs în comandă",
            icon: "plus",
            type: "default",
            "styling-mode": "outlined",
            hint: isComandaStorno.value ? 'Comenzile storno se generează automat din comanda sursă — nu se pot adăuga produse noi.' : undefined,
            disabled: liniiReadOnly.value || isComandaStorno.value,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (gridRef.value?.instance?.addRow()))
          }, null, 8, ["hint", "disabled"])
        ]),
        salveazaTotBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: "Salvează tot",
            icon: "save",
            type: "success",
            "styling-mode": "contained",
            disabled: liniiReadOnly.value,
            onClick: onSalveazaTot
          }, null, 8, ["disabled"])
        ]),
        rezervaToateBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: "Rezervă toate",
            icon: "check",
            type: "default",
            "styling-mode": "outlined",
            hint: localOrderData.value?.Stare === 'InLucru' ? 'Comanda e deja În Lucru — liniile nu mai pot fi modificate.' : undefined,
            disabled: isRezervandToate.value || editingByUser.value !== null || localOrderData.value?.Stare === 'InLucru',
            onClick: onRezervaToate
          }, null, 8, ["hint", "disabled"])
        ]),
        genereazaDocBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: "Generează document",
            icon: "doc",
            type: "default",
            "styling-mode": "outlined",
            hint: genereazaDocDisabledHint.value,
            disabled: editingByUser.value !== null || !!genereazaDocDisabledHint.value,
            onClick: onOpenGenereazaDocPopup
          }, null, 8, ["hint", "disabled"])
        ]),
        genereazaAvizBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: "Generează Documente Gestiune",
            icon: "plus",
            type: "default",
            "styling-mode": "outlined",
            hint: existaAvizActiv.value ? 'Există deja un aviz activ pentru această comandă. Anulați-l pentru a genera altul.' : undefined,
            disabled: editingByUser.value !== null || isGenereazaAviz.value || existaAvizActiv.value,
            onClick: onOpenGenereazaAvizPopup
          }, null, 8, ["hint", "disabled"])
        ]),
        genereazaFacturaBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: "Generează Factură",
            icon: "money",
            type: "default",
            "styling-mode": "outlined",
            disabled: editingByUser.value !== null || isGenereazaFactura.value,
            onClick: onOpenGenereazaFacturaPopup
          }, null, 8, ["disabled"])
        ]),
        refreshCursBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: "Refresh curs",
            icon: "refresh",
            type: "normal",
            "styling-mode": "outlined",
            disabled: isRefreshingCurs.value || localOrderData.value?.Stare === 'InLucru',
            onClick: onRefreshCursClick
          }, null, 8, ["disabled"])
        ]),
        stornoPartialBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: `Storno parțial (${liniiSelectate.value.length})`,
            icon: "revert",
            type: "normal",
            "styling-mode": "outlined",
            hint: !localOrderData.value?.Facturat ? 'Nu se poate genera storno pentru o comandă fără factură activă generată.' : undefined,
            disabled: isGenerandStorno.value || !localOrderData.value?.Facturat,
            onClick: onGenereazaStornoPartial
          }, null, 8, ["text", "hint", "disabled"])
        ]),
        stergeSelectateBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            text: `Șterge (${liniiSelectate.value.length})`,
            icon: "trash",
            type: "danger",
            "styling-mode": "text",
            onClick: onStergeLiniiSelectate
          }, null, 8, ["text"])
        ]),
        rezervareCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_66, [
            (data?.data?.Produs?.Stocabil === false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_67, "—"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["rezervare-text", getRezervareClass(data?.data?.ID, data?.data?.Cantitate)])
                  }, _toDisplayString(formatRezervare(data?.data?.ID, data?.data?.Cantitate)), 3),
                  (data?.data?.ProdusID && !isComandaStorno.value && currentCategorie.value?.RezervareDocID)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(["dx-icon dx-icon-edit edit-rezervare-btn", { 'edit-rezervare-btn--disabled': liniiReadOnly.value }]),
                        title: liniiReadOnly.value ? 'Comanda nu mai poate fi modificată în starea curentă.' : 'Modifică rezervare',
                        onClick: (e) => { if (e && typeof e.stopPropagation === 'function') e.stopPropagation(); if (!liniiReadOnly.value) onOpenRezerveLinie(data?.data); }
                      }, null, 10, _hoisted_68))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ]),
        pretUnitarCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(formatMoney(getPretUnitarDisplay(data))), 1),
            (localOrderData.value?.Valuta?.Simbol)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[97] || (_cache[97] = _createTextVNode(" ", -1)),
                  _createElementVNode("span", _hoisted_69, "(" + _toDisplayString(localOrderData.value.Valuta.Simbol) + ")", 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        pretNegociatCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(formatMoney(getPretNegociatDisplay(data))), 1)
        ]),
        valFaraDiscCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_70, _toDisplayString(formatMoney(calcCache.value[data.key]?.Valoare ?? data.data.Valoare)), 1)
        ]),
        valCuDiscCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_71, _toDisplayString(formatMoney(calcCache.value[data.key]?.ValoareFaraTVA ?? data.data.ValoareFaraTVA)), 1)
        ]),
        valDiscountCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(formatMoney(calcCache.value[data.key]?.ValoareDiscount ?? data.data.ValoareDiscount)), 1)
        ]),
        valTVACellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(formatMoney(calcCache.value[data.key]?.ValoareTVA ?? data.data.ValoareTVA)), 1)
        ]),
        valFaraTVACellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(formatMoney(calcCache.value[data.key]?.ValoareFaraTVA ?? data.data.ValoareFaraTVA)), 1)
        ]),
        totalCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_72, _toDisplayString(formatMoney(calcCache.value[data.key]?.TotalProdus ?? data.data.TotalProdus)), 1)
        ]),
        discountCellTemplate: _withCtx(({ data }) => [
          (data.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(data.value) + "%", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_74, "—"))
        ]),
        produsEditor: _withCtx(({ data: cellInfo }) => [
          _createVNode(_unref(DxDropDownBox), {
            value: cellInfo.value,
            "data-source": dsProduse,
            "display-expr": getProdusLookupDisplay,
            "value-expr": "Id",
            "show-clear-button": true,
            "drop-down-options": { width: 700, height: 450 },
            onOpened: onDropBoxOpened,
            onClosed: onDropBoxClosed,
            onValueChanged: (e) => { if (e.value == null) cellInfo.setValue(null); },
            onKeyDown: (e) => onProdusBoxKeyDown(e, cellInfo)
          }, {
            content: _withCtx(() => [
              _createVNode(_unref(DxDataGrid), {
                ref_key: "innerProdusGridRef",
                ref: innerProdusGridRef,
                "data-source": dsProduse,
                selection: { mode: 'single' },
                "focused-row-enabled": true,
                "hover-state-enabled": true,
                "selected-row-keys": cellInfo.value ? [cellInfo.value] : [],
                height: 410,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": true,
                "filter-row": { visible: true },
                paging: { pageSize: 25 },
                "key-expr": "Id",
                onContentReady: onProdusGridContentReady,
                onSelectionChanged: (e) => onProdusGridSelection(e, cellInfo),
                onKeyDown: (e) => onProdusGridKeyDown(e, cellInfo)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxColumn), {
                    "data-field": "Cod",
                    caption: "Cod",
                    width: 110
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "CodIntern",
                    caption: "Cod Intern",
                    width: 130
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "Nume",
                    caption: "Denumire"
                  })
                ]),
                _: 1
              }, 8, ["selected-row-keys", "onSelectionChanged", "onKeyDown"])
            ]),
            _: 2
          }, 1032, ["value", "onValueChanged", "onKeyDown"])
        ]),
        valutaListaEditor: _withCtx(({ data: cellInfo }) => [
          _createVNode(_unref(DxSelectBox), {
            value: cellInfo.value,
            "data-source": _unref(dsValuteLookup),
            "display-expr": "Simbol",
            "value-expr": "Id",
            "search-enabled": true,
            "search-expr": "Simbol",
            "show-clear-button": true,
            placeholder: "Valută...",
            onValueChanged: (e) => { cellInfo.setValue(e.value); recalculeazaLinieLive({ dataField: 'PretListaValutaID', rowData: cellInfo.data, rowKey: cellInfo.row?.key, rowIndex: cellInfo.rowIndex, newValue: e.value }); },
            onKeyDown: _cache[10] || (_cache[10] = (e) => { if (e.event.key === 'Enter') e.event.stopPropagation(); })
          }, null, 8, ["value", "data-source", "onValueChanged"])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxStateStoring), {
            enabled: true,
            type: "localStorage",
            "storage-key": "grid-detalii-comenzi"
          }),
          _createVNode(_unref(DxSelection), {
            mode: "multiple",
            "show-check-boxes-mode": "always"
          }),
          _createVNode(_unref(DxEditing), {
            "allow-updating": allowUpdatingFn,
            "allow-adding": false,
            "allow-deleting": false,
            mode: "batch",
            "use-icons": true,
            "confirm-delete": false,
            "new-row-position": "last"
          }),
          _createVNode(_unref(DxColumn), {
            type: "buttons",
            fixed: true,
            "fixed-position": "right",
            visible: false
          }),
          _createVNode(_unref(DxToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DxItem), {
                location: "before",
                template: "fullscreenBtn"
              }),
              _createVNode(_unref(DxItem), {
                location: "before",
                template: "salveazaTotBtn"
              }),
              _createVNode(_unref(DxItem), {
                location: "before",
                template: "adaugaProdusBtn"
              }),
              (drepturi.value.RezervaComenzi && !isReadOnly.value && !isComandaStorno.value && currentCategorie.value?.RezervareDocID)
                ? (_openBlock(), _createBlock(_unref(DxItem), {
                    key: 0,
                    location: "before",
                    template: "rezervaToateBtn"
                  }))
                : _createCommentVNode("", true),
              (drepturi.value.ModificaPretComenzi && !isReadOnly.value)
                ? (_openBlock(), _createBlock(_unref(DxItem), {
                    key: 1,
                    location: "before",
                    template: "refreshCursBtn"
                  }))
                : _createCommentVNode("", true),
              (false && localOrderData.value?.Stare !== 'Anulata')
                ? (_openBlock(), _createBlock(_unref(DxItem), {
                    key: 2,
                    location: "before",
                    template: "genereazaDocBtn"
                  }))
                : _createCommentVNode("", true),
              (drepturi.value.GenereazaAvize && ['InLucru','Finalizata'].includes(localOrderData.value?.Stare ?? ''))
                ? (_openBlock(), _createBlock(_unref(DxItem), {
                    key: 3,
                    location: "before",
                    template: "genereazaAvizBtn"
                  }))
                : _createCommentVNode("", true),
              (drepturi.value.GenereazaFacturi && isClientOrder.value && ['InLucru','Finalizata'].includes(localOrderData.value?.Stare ?? '') && !localOrderData.value?.Facturat)
                ? (_openBlock(), _createBlock(_unref(DxItem), {
                    key: 4,
                    location: "before",
                    template: "genereazaFacturaBtn"
                  }))
                : _createCommentVNode("", true),
              (drepturi.value.DuplicaComenzi && liniiSelectate.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(DxItem), {
                    key: 5,
                    location: "before",
                    template: "stornoPartialBtn"
                  }))
                : _createCommentVNode("", true),
              (!liniiReadOnly.value && liniiSelectate.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(DxItem), {
                    key: 6,
                    location: "before",
                    template: "stergeSelectateBtn"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(DxItem), { name: "columnChooserButton" })
            ]),
            _: 1
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "NrCrt",
            caption: "Numar curent",
            hint: "Numarul de ordine al liniei in comanda",
            "data-type": "number",
            width: "55",
            alignment: "center",
            "allow-editing": false,
            "sort-order": "asc",
            "sort-index": 0
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ProdusID",
            caption: "Produs",
            hint: "Produsul sau serviciul din linia de comanda",
            "min-width": 200,
            "calculate-display-value": getProdusNume,
            "edit-cell-template": "produsEditor"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxRequiredRule), { message: "Produsul este obligatoriu." })
            ]),
            _: 1
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Produs.Cod",
            caption: "Cod",
            hint: "Codul de catalog al produsului",
            width: "110",
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Produs.CodIntern",
            caption: "Cod Intern",
            hint: "Codul intern de gestiune al produsului",
            width: "110",
            "allow-editing": false,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Cantitate",
            caption: "Cantitate",
            hint: "Numărul de unități (bucăți) dintr-un anumit produs care au fost adăugate pe acea linie de comandă.",
            "data-type": "number",
            width: "80",
            alignment: "right"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "CantitateRezervata",
            caption: "Cantitate Rezervată",
            hint: "Cantitate totală / Cantitate rezervată din stoc",
            width: 130,
            "allow-editing": false,
            alignment: "center",
            "cell-template": "rezervareCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretLista",
            caption: "Pret Lista",
            hint: "Prețul standard de catalog sau de bază al unui singur produs, stabilit de obicei în valută (fără discount și fără TVA).",
            "data-type": "number",
            format: formatRO,
            width: "115",
            alignment: "right"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretListaValutaID",
            caption: "Valuta Pret Lista",
            hint: "Valuta in care este exprimat pretul de lista",
            width: "90",
            "edit-cell-template": "valutaListaEditor"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxLookup), {
                "data-source": _unref(dsValuteLookup),
                "display-expr": "Simbol",
                "value-expr": "Id"
              }, null, 8, ["data-source"])
            ]),
            _: 1
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretListaCurs",
            caption: "Curs Pret Lista",
            hint: "Cursul de schimb valutar utilizat de sistem pentru a converti prețul produsului din valută în moneda națională (RON).",
            "data-type": "number",
            format: formatRO,
            width: "110",
            alignment: "right",
            visible: false,
            "allow-editing": false,
            "calculate-cell-value": calcCursLista
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretUnitar",
            caption: "Pret Unitar",
            hint: "Prețul de bază al unei singure bucăți, în moneda comenzii, înainte de aplicarea discounturilor sau a taxelor. Este câmpul editabil din care se derivă Pret cu Discount.",
            "data-type": "number",
            format: formatRO,
            width: "115",
            alignment: "right",
            "cell-template": "pretUnitarCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            caption: "Valoare fara Discount",
            hint: "Costul cumulat al produselor de pe acea linie la preț întreg, calculat prin înmulțirea prețului unitar cu cantitatea (fără discount și fără TVA).",
            "data-type": "number",
            format: formatRO,
            width: "160",
            alignment: "right",
            "allow-editing": false,
            "cell-template": "valFaraDiscCellTemplate",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DiscountProc",
            caption: "Discount %",
            hint: "Procentul de reducere comercială (%) acordat clientului pentru produsul respectiv.",
            "data-type": "number",
            width: "90",
            alignment: "center",
            "cell-template": "discountCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ValoareDiscount",
            caption: "Reducere Aplicată",
            hint: "Suma totală în bani (RON) care se scade din valoarea produselor de pe acea linie ca urmare a aplicării procentului de discount.",
            "data-type": "number",
            format: formatRO,
            width: "160",
            alignment: "right",
            "allow-editing": false,
            visible: false,
            "cell-template": "valDiscountCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretNegociat",
            caption: "Pret cu Discount",
            hint: "Prețul final stabilit de comun acord cu clientul — se calculează automat din Pret Unitar și Discount %, nu se editează direct.",
            "data-type": "number",
            format: formatRO,
            width: "130",
            alignment: "right",
            "cell-template": "pretNegociatCellTemplate",
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            caption: "Stoc Efectiv",
            hint: "Stocul fizic disponibil al produsului in gestiune",
            "data-type": "number",
            format: formatRO,
            width: "115",
            alignment: "right",
            "allow-editing": false,
            "calculate-cell-value": calcStocEfectiv,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            caption: "Stoc Rezervat",
            hint: "Cantitatea rezervata din stoc pentru alte comenzi",
            "data-type": "number",
            format: formatRO,
            width: "115",
            alignment: "right",
            "allow-editing": false,
            "calculate-cell-value": calcStocRezervat,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            caption: "Stoc Ramas",
            hint: "Stocul ramas disponibil dupa scaderea rezervarilor (Stoc Efectiv - Stoc Rezervat)",
            "data-type": "number",
            format: formatRO,
            width: "110",
            alignment: "right",
            "allow-editing": false,
            "calculate-cell-value": calcStocRamas,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TVA",
            caption: "TVA %",
            hint: "Procentul de TVA aplicat pe aceasta linie",
            "data-type": "number",
            width: "75",
            alignment: "center",
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Valoare",
            caption: "Valoare cu Discount",
            hint: "Baza de impozitare pentru linia respectivă; valoarea netă totală a produselor după ce s-au aplicat discounturile sau modificările de preț, dar înainte de adăugarea taxelor.",
            "data-type": "number",
            format: formatRO,
            width: "150",
            alignment: "right",
            "allow-editing": false,
            "cell-template": "valCuDiscCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ValoareTVA",
            caption: "Valoare TVA",
            hint: "Suma Taxei pe Valoarea Adăugată calculată strict pentru produsele de pe acea linie (prin aplicarea cotei de TVA la valoarea fără TVA).",
            "data-type": "number",
            format: formatRO,
            width: "110",
            alignment: "right",
            "allow-editing": false,
            visible: false,
            "cell-template": "valTVACellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TotalProdus",
            caption: "Total cu TVA",
            hint: "Valoarea totală brută (cu discounturi aplicate și TVA inclus) pentru cantitatea totală din produsul respectiv. Reprezintă costul final al acelei linii din comandă.",
            "data-type": "number",
            format: formatRO,
            width: "130",
            alignment: "right",
            "allow-editing": false,
            "cell-template": "totalCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Furnizor.Nume",
            caption: "Furnizor",
            visible: false,
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "FurnizorPret",
            caption: "Preț Furnizor",
            hint: "Prețul de referință al produsului în relația cu furnizorul (poate fi prețul de achiziție sau prețul recomandat de producător).",
            "data-type": "number",
            format: formatRO,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "FurnizorPretValuta.Simbol",
            caption: "Valută Furnizor",
            visible: false,
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TermenLivrare",
            caption: "Termen Livrare",
            "data-type": "date",
            format: "dd.MM.yyyy",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "GarantieLuni",
            caption: "Garanție (luni)",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ValoareFaraTVA",
            caption: "Val. fără TVA",
            hint: "Baza de impozitare pentru linia respectivă; valoarea netă totală a produselor după ce s-au aplicat discounturile sau modificările de preț, dar înainte de adăugarea taxelor.",
            "data-type": "number",
            format: formatRO,
            visible: false,
            "allow-editing": false,
            "cell-template": "valFaraTVACellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Document.Tip.Cod",
            caption: "Tip Document",
            visible: false,
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Document.Numar",
            caption: "Nr. Document",
            visible: false,
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ClasificatieBugetara.Cod",
            caption: "Clasificație Bugetară",
            visible: false,
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ClasificatieBugetara.Denumire",
            caption: "Den. Clasificație",
            visible: false,
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "SursaFinantare",
            caption: "Sursă Finanțare",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Facturabil",
            caption: "Facturabil",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ProdusCodCPV",
            caption: "Cod CPV",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Produs.Nume",
            caption: "Produs (nav)",
            visible: false,
            "allow-editing": false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Explicatie",
            caption: "Explicație",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Anulata",
            caption: "Anulată",
            visible: false,
            "allow-editing": false
          })
        ]),
        _: 1
      }, 8, ["data-source"]),
      _createVNode(_unref(DxPopup), {
        visible: showRezervareLiniePopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        width: 460,
        height: 'auto',
        "wrapper-attr": { class: 'rezervare-stoc-popup' },
        onHidden: _cache[13] || (_cache[13] = ($event: any) => (showRezervareLiniePopup.value = false)),
        onShown: onRezervareLiniePopupShown
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _cache[98] || (_cache[98] = _createElementVNode("div", { class: "ehp-header-main" }, [
                _createElementVNode("i", { class: "dx-icon dx-icon-box ehp-icon" }),
                _createElementVNode("div", { class: "ehp-texts" }, [
                  _createElementVNode("span", { class: "ehp-title" }, "Rezervare stoc")
                ])
              ], -1)),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (showRezervareLiniePopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("p", _hoisted_78, _toDisplayString(rezervareLinieProdusNume.value), 1),
              _createElementVNode("div", _hoisted_79, [
                _cache[99] || (_cache[99] = _createElementVNode("span", { class: "edit-label" }, "Stoc disponibil", -1)),
                _createElementVNode("span", _hoisted_80, _toDisplayString(rezervareLinieStocDisponibil.value ?? '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("span", _hoisted_82, "Cantitate de rezervat (max comandat: " + _toDisplayString(rezervareLinieCantitateMax.value) + ")", 1),
                _createVNode(_unref(DxNumberBox), {
                  ref_key: "rezervareCantitateRef",
                  ref: rezervareCantitateRef,
                  value: rezervareLinieCantitate.value,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((rezervareLinieCantitate).value = $event)),
                  min: 0,
                  max: rezervareLinieCantitateMax.value,
                  format: formatRO,
                  onEnterKey: onConfirmRezerveLinie
                }, null, 8, ["value", "max"])
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Confirmă', type: 'default', onClick: onConfirmRezerveLinie }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Renunță', stylingMode: 'outlined', onClick: () => showRezervareLiniePopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showGenereazaDocPopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        width: 480,
        height: 360,
        onHidden: onCloseGenereazaDocPopup
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _cache[101] || (_cache[101] = _createElementVNode("i", { class: "dx-icon dx-icon-doc ehp-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_86, [
                  _cache[100] || (_cache[100] = _createElementVNode("span", { class: "ehp-title" }, "Generează document din comandă", -1)),
                  _createElementVNode("span", _hoisted_87, _toDisplayString(localOrderData.value?.Cod), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (onCloseGenereazaDocPopup()))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _cache[102] || (_cache[102] = _createElementVNode("span", { class: "edit-label" }, "Tip document *", -1)),
                _createVNode(_unref(DxSelectBox), {
                  value: genDocTipId.value,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((genDocTipId).value = $event)),
                  "data-source": _unref(dsTipuriDoc),
                  "display-expr": "Nume",
                  "value-expr": "Id",
                  placeholder: "Selectează tipul documentului...",
                  "search-enabled": true,
                  "search-expr": "Nume"
                }, null, 8, ["value", "data-source"])
              ]),
              _createElementVNode("div", _hoisted_90, [
                _cache[103] || (_cache[103] = _createElementVNode("span", { class: "edit-label" }, "Data documentului", -1)),
                _createVNode(_unref(DxDateBox), {
                  value: genDocData.value,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((genDocData).value = $event)),
                  "display-format": "dd.MM.yyyy",
                  type: "date"
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _cache[104] || (_cache[104] = _createElementVNode("span", { class: "edit-label" }, "Observații", -1)),
                _createVNode(_unref(DxTextBox), {
                  value: genDocObs.value,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((genDocObs).value = $event)),
                  placeholder: "Observații (opțional)..."
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: isGenereazandDoc.value ? 'Se generează...' : 'Generează', type: 'default', disabled: isGenereazandDoc.value || !genDocTipId.value, onClick: onGenereazaDocument }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Renunță', stylingMode: 'outlined', disabled: isGenereazandDoc.value, onClick: () => onCloseGenereazaDocPopup() }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showMotivPopup.value,
        title: "Motiv anulare",
        width: 440,
        height: 220,
        "show-close-button": true,
        "drag-enabled": true,
        onHidden: _cache[19] || (_cache[19] = ($event: any) => (showMotivPopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_92, [
            _cache[105] || (_cache[105] = _createElementVNode("p", { class: "motiv-label" }, "Introduceți motivul anulării comenzii:", -1)),
            _createVNode(_unref(DxTextBox), {
              value: motivText.value,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((motivText).value = $event)),
              placeholder: "Motiv..."
            }, null, 8, ["value"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Confirmă', type: 'danger', onClick: onConfirmMotiv }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Renunță', stylingMode: 'outlined', onClick: () => showMotivPopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showEditHeaderPopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        "close-on-outside-click": false,
        width: 640,
        height: 'auto',
        onHidden: _cache[30] || (_cache[30] = ($event: any) => (showEditHeaderPopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _cache[107] || (_cache[107] = _createElementVNode("i", { class: "dx-icon dx-icon-edit ehp-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_96, [
                  _cache[106] || (_cache[106] = _createElementVNode("span", { class: "ehp-title" }, "Editează comandă", -1)),
                  _createElementVNode("span", _hoisted_97, _toDisplayString(localOrderData.value?.Cod), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (showEditHeaderPopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _cache[109] || (_cache[109] = _createElementVNode("div", { class: "form-group-caption" }, "Tip și Partener", -1)),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _cache[108] || (_cache[108] = _createElementVNode("label", null, "Tip Comandă", -1)),
                      _createVNode(_unref(DxSelectBox), {
                        value: headerDraft.value.Tipcomanda,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((headerDraft.value.Tipcomanda) = $event)),
                        "data-source": categoriiComenzi.value,
                        "display-expr": "Denumire",
                        "value-expr": "TipComanda",
                        "search-enabled": true,
                        "search-expr": "Denumire",
                        "show-clear-button": true,
                        onValueChanged: onTipComandaHeaderChanged
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("label", null, _toDisplayString(partenerLabelHeader.value), 1),
                      _createVNode(_unref(DxSelectBox), {
                        value: headerDraft.value.ClientId,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((headerDraft.value.ClientId) = $event)),
                        "data-source": dsParteneriHeader.value,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        "search-enabled": true,
                        "search-expr": "Nume",
                        "show-clear-button": true,
                        disabled: headerDraft.value.Tipcomanda == null,
                        placeholder: "Selectați partenerul...",
                        onSelectionChanged: onPartenerHeaderChanged
                      }, null, 8, ["value", "data-source", "disabled"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _cache[117] || (_cache[117] = _createElementVNode("div", { class: "form-group-caption" }, "Detalii comandă", -1)),
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _cache[110] || (_cache[110] = _createElementVNode("label", null, [
                        _createTextVNode("Agent "),
                        _createElementVNode("span", { class: "required-star" }, "*")
                      ], -1)),
                      _createVNode(_unref(DxSelectBox), {
                        value: headerDraft.value.AgentId,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((headerDraft.value.AgentId) = $event)),
                        "data-source": dsAgenti.value,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "search-enabled": true,
                        "search-expr": "Nume",
                        "show-clear-button": true,
                        placeholder: "Selectați agentul..."
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _cache[111] || (_cache[111] = _createElementVNode("label", null, "Valută", -1)),
                      _createVNode(_unref(DxSelectBox), {
                        value: headerDraft.value.ValutaId,
                        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((headerDraft.value.ValutaId) = $event)),
                        "data-source": dsValute.value,
                        "display-expr": "Simbol",
                        "value-expr": "Id",
                        "search-enabled": true,
                        "search-expr": "Simbol",
                        "show-clear-button": true,
                        placeholder: "Selectați valuta..."
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _cache[112] || (_cache[112] = _createElementVNode("label", null, "Data Comenzii", -1)),
                      _createVNode(_unref(DxDateBox), {
                        value: headerDraft.value.DataComenzii,
                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((headerDraft.value.DataComenzii) = $event)),
                        "display-format": "dd.MM.yyyy",
                        type: "date"
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _cache[113] || (_cache[113] = _createElementVNode("label", null, "Termen Livrare", -1)),
                      _createVNode(_unref(DxDateBox), {
                        value: headerDraft.value.TermenLivrare,
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((headerDraft.value.TermenLivrare) = $event)),
                        "display-format": "dd.MM.yyyy",
                        type: "date",
                        "show-clear-button": true
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      _cache[114] || (_cache[114] = _createElementVNode("label", null, "PO (BT-13)", -1)),
                      _createVNode(_unref(DxSelectBox), {
                        value: headerDraft.value.ProiectId,
                        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((headerDraft.value.ProiectId) = $event)),
                        "data-source": dsProiecte.value,
                        "display-expr": (item) => item ? `${item.Cod}${item.Nume ? ' — ' + item.Nume : ''}` : '',
                        "value-expr": "Id",
                        "search-enabled": true,
                        "search-expr": "Cod",
                        "show-clear-button": true,
                        placeholder: "Selectați PO..."
                      }, null, 8, ["value", "data-source", "display-expr"])
                    ]),
                    (partenerLabelHeader.value === 'Client')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                          _createVNode(_unref(DxSwitch), {
                            value: headerDraft.value.LivrareDirectaFurnizor,
                            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((headerDraft.value.LivrareDirectaFurnizor) = $event)),
                            onValueChanged: onToggleLivrareDirectaFurnizor
                          }, null, 8, ["value"]),
                          _cache[115] || (_cache[115] = _createElementVNode("label", { class: "switch-label" }, [
                            _createTextVNode(" Livrare directă de la furnizor "),
                            _createElementVNode("span", { class: "switch-hint" }, "Furnizorul livrează marfa direct la client, fără să treacă prin gestiunea proprie — comanda poate fi pusă în lucru și facturată fără rezervare de stoc.")
                          ], -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_113, [
                      _cache[116] || (_cache[116] = _createElementVNode("label", null, "Observații", -1)),
                      _createVNode(_unref(DxTextBox), {
                        value: headerDraft.value.Observatii,
                        "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((headerDraft.value.Observatii) = $event)),
                        "show-clear-button": true,
                        placeholder: "Observații comenzii..."
                      }, null, 8, ["value"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: isSavingHeader.value ? 'Se salvează...' : 'Salvează', type: 'default', disabled: isSavingHeader.value || !headerDraft.value.AgentId, onClick: onSaveHeader }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Anulează', stylingMode: 'outlined', disabled: isSavingHeader.value, onClick: () => showEditHeaderPopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showAdaugareRapidaPopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        "close-on-outside-click": false,
        width: 1400,
        height: 680,
        "wrapper-attr": { class: 'rapida-adaugare-popup' },
        onHidden: _cache[33] || (_cache[33] = ($event: any) => (showAdaugareRapidaPopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("div", _hoisted_115, [
              _cache[118] || (_cache[118] = _createElementVNode("div", { class: "ehp-header-main" }, [
                _createElementVNode("i", { class: "dx-icon dx-icon-add ehp-icon" }),
                _createElementVNode("div", { class: "ehp-texts" }, [
                  _createElementVNode("span", { class: "ehp-title" }, "Adăugare rapidă linii"),
                  _createElementVNode("span", { class: "ehp-subtitle" }, "Lipiți coduri — câte unul pe linie")
                ])
              ], -1)),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (showAdaugareRapidaPopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_116, [
              _withDirectives(_createElementVNode("textarea", {
                ref_key: "rapidaTextareaRef",
                ref: rapidaTextareaRef,
                class: "rapida-textarea",
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((rapida_coduri).value = $event)),
                placeholder: "Lipiți coduri cu Ctrl+V — câte unul pe linie...",
                rows: "4"
              }, null, 512), [
                [_vModelText, rapida_coduri.value]
              ]),
              (rapida_isProcessing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_117, "Se procesează..."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_118, [
              (rapida_linii.value.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_119, [
                      _cache[119] || (_cache[119] = _createTextVNode(" Rezultate ", -1)),
                      (rapida_liniiGasite.value.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString(rapida_liniiGasite.value.length) + " găsite", 1))
                        : _createCommentVNode("", true),
                      (rapida_liniiNegasite.value.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(rapida_liniiNegasite.value.length) + " negăsite", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("table", _hoisted_123, [
                        _cache[120] || (_cache[120] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { style: {"width":"28px"} }),
                            _createElementVNode("th", { style: {"width":"110px"} }, "Cod"),
                            _createElementVNode("th", { style: {"min-width":"140px"} }, "Denumire"),
                            _createElementVNode("th", { style: {"width":"90px"} }, "Cantitate"),
                            _createElementVNode("th", { style: {"width":"110px"} }, "Preț Unitar"),
                            _createElementVNode("th", { style: {"min-width":"220px"} }, "Furnizor"),
                            _createElementVNode("th", { style: {"width":"110px"} }, "Preț Furnizor")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rapida_linii.value, (linie, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: i,
                              class: _normalizeClass(linie.gasit ? 'rapida-row-ok' : 'rapida-row-err')
                            }, [
                              _createElementVNode("td", _hoisted_124, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["dx-icon", linie.gasit ? 'dx-icon-check' : 'dx-icon-close'])
                                }, null, 2)
                              ]),
                              _createElementVNode("td", _hoisted_125, _toDisplayString(linie.cod), 1),
                              _createElementVNode("td", _hoisted_126, [
                                (linie.gasit)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(linie.produs.Nume), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_128, "Nu a fost găsit"))
                              ]),
                              _createElementVNode("td", _hoisted_129, [
                                (linie.gasit)
                                  ? (_openBlock(), _createBlock(_unref(DxNumberBox), {
                                      key: 0,
                                      value: linie.cantitate,
                                      "onUpdate:value": ($event: any) => ((linie.cantitate) = $event),
                                      min: 0.0001,
                                      format: formatRO,
                                      width: "100%"
                                    }, null, 8, ["value", "onUpdate:value"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_130, [
                                (linie.gasit)
                                  ? (_openBlock(), _createBlock(_unref(DxNumberBox), {
                                      key: 0,
                                      value: linie.pretUnitar,
                                      "onUpdate:value": ($event: any) => ((linie.pretUnitar) = $event),
                                      min: 0,
                                      format: formatRO,
                                      width: "100%"
                                    }, null, 8, ["value", "onUpdate:value"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_131, [
                                (linie.gasit)
                                  ? (_openBlock(), _createBlock(_unref(DxSelectBox), {
                                      key: 0,
                                      value: linie.furnizorId,
                                      "onUpdate:value": ($event: any) => ((linie.furnizorId) = $event),
                                      "data-source": dsFurnizoriPO.value,
                                      "display-expr": "Nume",
                                      "value-expr": "ID",
                                      "search-enabled": true,
                                      "search-expr": "Nume",
                                      "show-clear-button": true,
                                      width: "100%"
                                    }, null, 8, ["value", "onUpdate:value", "data-source"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_132, [
                                (linie.gasit)
                                  ? (_openBlock(), _createBlock(_unref(DxNumberBox), {
                                      key: 0,
                                      value: linie.pretFurnizor,
                                      "onUpdate:value": ($event: any) => ((linie.pretFurnizor) = $event),
                                      min: 0,
                                      format: formatRO,
                                      width: "100%"
                                    }, null, 8, ["value", "onUpdate:value"]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_133, [...(_cache[121] || (_cache[121] = [
                    _createElementVNode("i", {
                      class: "dx-icon dx-icon-paste",
                      style: {"font-size":"32px","color":"#cbd5e1","margin-bottom":"10px"}
                    }, null, -1),
                    _createElementVNode("span", null, "Lipiți coduri în câmpul de mai sus (Ctrl+V)", -1)
                  ]))]))
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: rapida_isAdaugand.value ? 'Se adaugă...' : `Adaugă ${rapida_liniiGasite.value.length} linie(i)`, type: 'default', disabled: rapida_isAdaugand.value || rapida_liniiGasite.value.length === 0, onClick: onAdaugaToate }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Închide', stylingMode: 'outlined', onClick: () => showAdaugareRapidaPopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showEsalonariPopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        "close-on-outside-click": false,
        width: 900,
        height: 550,
        onHidden: _cache[35] || (_cache[35] = ($event: any) => (showEsalonariPopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_134, [
            _createElementVNode("div", _hoisted_135, [
              _createElementVNode("div", _hoisted_136, [
                _cache[123] || (_cache[123] = _createElementVNode("i", { class: "dx-icon dx-icon-clock ehp-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_137, [
                  _cache[122] || (_cache[122] = _createElementVNode("span", { class: "ehp-title" }, "Eșalonări livrare", -1)),
                  _createElementVNode("span", _hoisted_138, _toDisplayString(esalonariDetaliuNume.value), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (showEsalonariPopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_139, [
              _createVNode(_unref(DxDataGrid), {
                ref_key: "esalonariGridRef",
                ref: esalonariGridRef,
                "data-source": esalonariStore.value,
                "key-expr": "Id",
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": true,
                "row-alternation-enabled": true,
                "hover-state-enabled": true,
                height: 370,
                onRowInserting: onEsalonareInserting,
                onRowUpdating: onEsalonareUpdating,
                onRowRemoving: onEsalonareRemoving
              }, {
                esalonareStatusTemplate: _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    style: _normalizeStyle(getEsalonareStatusStyle(data.value))
                  }, _toDisplayString(getEsalonareStatusNume(data.value)), 5)
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(DxEditing), {
                    "allow-updating": !isReadOnly.value,
                    "allow-adding": !isReadOnly.value,
                    "allow-deleting": !isReadOnly.value,
                    mode: "row",
                    "use-icons": true,
                    "confirm-delete": false
                  }, null, 8, ["allow-updating", "allow-adding", "allow-deleting"]),
                  _createVNode(_unref(DxColumn), {
                    type: "buttons",
                    width: 80
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "DataLivrare",
                    caption: "Data Livrare",
                    "data-type": "date",
                    format: "dd.MM.yyyy",
                    width: 140,
                    alignment: "center"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "Cantitate",
                    caption: "Cantitate",
                    "data-type": "number",
                    format: formatRO,
                    width: 110,
                    alignment: "right"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "CantitateStoc",
                    caption: "Cant. Stoc",
                    "data-type": "number",
                    format: formatRO,
                    width: 110,
                    alignment: "right"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "CantitateTotal",
                    caption: "Cant. Total",
                    "data-type": "number",
                    format: formatRO,
                    width: 115,
                    alignment: "right"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "Status",
                    caption: "Status",
                    width: 170,
                    "cell-template": "esalonareStatusTemplate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxLookup), {
                        "data-source": esalonareStatusuri,
                        "display-expr": "Denumire",
                        "value-expr": "Id"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "CantitateDorita",
                    caption: "Cant. Dorită",
                    "data-type": "number",
                    format: formatRO,
                    width: 120,
                    alignment: "right",
                    visible: false
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "CantitateDinNecesar",
                    caption: "Din Necesar",
                    "data-type": "number",
                    format: formatRO,
                    width: 120,
                    alignment: "right",
                    visible: false
                  })
                ]),
                _: 1
              }, 8, ["data-source"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Închide', stylingMode: 'outlined', onClick: () => showEsalonariPopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showReceptiePopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        "close-on-outside-click": false,
        width: 820,
        height: 560,
        "wrapper-attr": { class: 'receptie-popup' },
        onHidden: _cache[40] || (_cache[40] = ($event: any) => (showReceptiePopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("div", _hoisted_141, [
              _createElementVNode("div", _hoisted_142, [
                _cache[125] || (_cache[125] = _createElementVNode("i", { class: "dx-icon dx-icon-import ehp-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_143, [
                  _cache[124] || (_cache[124] = _createElementVNode("span", { class: "ehp-title" }, "Recepție Marfă — NIR", -1)),
                  _createElementVNode("span", _hoisted_144, _toDisplayString(localOrderData.value?.Cod), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[36] || (_cache[36] = ($event: any) => (showReceptiePopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                _cache[126] || (_cache[126] = _createElementVNode("label", { class: "aviz-label" }, "Data NIR", -1)),
                _createVNode(_unref(DxDateBox), {
                  value: receptieFormData.value.Data,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((receptieFormData.value.Data) = $event)),
                  type: "date",
                  "display-format": "dd.MM.yyyy",
                  width: '100%'
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_147, [
                _cache[127] || (_cache[127] = _createElementVNode("label", { class: "aviz-label" }, "Gestiune intrare (opțional)", -1)),
                _createVNode(_unref(DxSelectBox), {
                  value: receptieFormData.value.GestiuneId,
                  "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((receptieFormData.value.GestiuneId) = $event)),
                  "data-source": _unref(dsGestiuni),
                  "display-expr": "Nume",
                  "value-expr": "Id",
                  "show-clear-button": true,
                  placeholder: "Se utilizează gestiunea implicită",
                  width: '100%'
                }, null, 8, ["value", "data-source"])
              ]),
              _createElementVNode("div", _hoisted_148, [
                _cache[128] || (_cache[128] = _createElementVNode("label", { class: "aviz-label" }, "Observații", -1)),
                _createVNode(_unref(DxTextBox), {
                  value: receptieFormData.value.Observatii,
                  "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((receptieFormData.value.Observatii) = $event)),
                  width: '100%'
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_149, [
              _createVNode(_unref(DxDataGrid), {
                "data-source": receptieLinii.value,
                "key-expr": "LinieId",
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": true,
                "row-alternation-enabled": true,
                "hover-state-enabled": true,
                height: "100%"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxEditing), {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "ProdusNume",
                    caption: "Produs",
                    "allow-editing": false,
                    "min-width": 160
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "CantitateComandataOrig",
                    caption: "Cant. Comandată",
                    "data-type": "number",
                    format: formatRO,
                    width: 150,
                    alignment: "right",
                    "allow-editing": false
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "CantitateReceptionata",
                    caption: "Cant. Recepționată",
                    "data-type": "number",
                    format: formatRO,
                    width: 160,
                    alignment: "right"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "PretAchizitie",
                    caption: "Preț Achiziție",
                    "data-type": "number",
                    format: formatRO,
                    width: 140,
                    alignment: "right"
                  })
                ]),
                _: 1
              }, 8, ["data-source"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: isGenereazaReceptie.value ? 'Se salvează...' : 'Recepționează', type: 'default', disabled: isGenereazaReceptie.value, onClick: onConfirmReceptie }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Anulează', stylingMode: 'outlined', disabled: isGenereazaReceptie.value, onClick: () => showReceptiePopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showGenereazaFacturaPopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        "close-on-outside-click": false,
        width: 520,
        height: 340,
        "wrapper-attr": { class: 'aviz-popup' },
        onHidden: _cache[46] || (_cache[46] = ($event: any) => (showGenereazaFacturaPopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_150, [
            _createElementVNode("div", _hoisted_151, [
              _createElementVNode("div", _hoisted_152, [
                _cache[130] || (_cache[130] = _createElementVNode("i", { class: "dx-icon dx-icon-money ehp-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_153, [
                  _cache[129] || (_cache[129] = _createElementVNode("span", { class: "ehp-title" }, "Generare Factură", -1)),
                  _createElementVNode("span", _hoisted_154, _toDisplayString(localOrderData.value?.Cod), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (showGenereazaFacturaPopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_155, [
              _createElementVNode("div", _hoisted_156, [
                _createElementVNode("div", _hoisted_157, [
                  _cache[131] || (_cache[131] = _createElementVNode("label", { class: "aviz-label" }, "Data facturii", -1)),
                  _createVNode(_unref(DxDateBox), {
                    value: facturaFormData.value.Data,
                    "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((facturaFormData.value.Data) = $event)),
                    type: "date",
                    "display-format": "dd.MM.yyyy",
                    width: '100%'
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_158, [
                  _cache[132] || (_cache[132] = _createElementVNode("label", { class: "aviz-label" }, "Scadență (opțional)", -1)),
                  _createVNode(_unref(DxDateBox), {
                    value: facturaFormData.value.Scadenta,
                    "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((facturaFormData.value.Scadenta) = $event)),
                    type: "date",
                    "display-format": "dd.MM.yyyy",
                    "show-clear-button": true,
                    width: '100%'
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_159, [
                _cache[133] || (_cache[133] = _createElementVNode("label", { class: "aviz-label" }, "Aviz sursă (opțional — lasă gol pentru a factura comanda direct)", -1)),
                _createVNode(_unref(DxSelectBox), {
                  value: facturaFormData.value.AvizId,
                  "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((facturaFormData.value.AvizId) = $event)),
                  "data-source": avize.value,
                  "display-expr": "Numar",
                  "value-expr": "Id",
                  "show-clear-button": true,
                  placeholder: "Facturare directă din comandă",
                  width: '100%'
                }, null, 8, ["value", "data-source"])
              ]),
              _createElementVNode("div", _hoisted_160, [
                _cache[134] || (_cache[134] = _createElementVNode("label", { class: "aviz-label" }, "Observații", -1)),
                _createVNode(_unref(DxTextBox), {
                  value: facturaFormData.value.Observatii,
                  "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((facturaFormData.value.Observatii) = $event)),
                  width: '100%'
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: isGenereazaFactura.value ? 'Se generează...' : 'Generează', type: 'default', disabled: isGenereazaFactura.value, onClick: onConfirmGenereazaFactura }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Anulează', stylingMode: 'outlined', disabled: isGenereazaFactura.value, onClick: () => showGenereazaFacturaPopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showGenereazaAvizPopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        "close-on-outside-click": false,
        width: 480,
        height: 390,
        "wrapper-attr": { class: 'aviz-popup' },
        onHidden: _cache[53] || (_cache[53] = ($event: any) => (showGenereazaAvizPopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_161, [
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _cache[136] || (_cache[136] = _createElementVNode("i", { class: "dx-icon dx-icon-export ehp-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_164, [
                  _cache[135] || (_cache[135] = _createElementVNode("span", { class: "ehp-title" }, "Generare Aviz Expediție", -1)),
                  _createElementVNode("span", _hoisted_165, _toDisplayString(localOrderData.value?.Cod), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[47] || (_cache[47] = ($event: any) => (showGenereazaAvizPopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_166, [
              _createElementVNode("div", _hoisted_167, [
                _cache[137] || (_cache[137] = _createElementVNode("label", { class: "aviz-label" }, "Data avizului", -1)),
                _createVNode(_unref(DxDateBox), {
                  value: avizFormData.value.Data,
                  "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((avizFormData.value.Data) = $event)),
                  type: "date",
                  "display-format": "dd.MM.yyyy",
                  width: '100%'
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_168, [
                _cache[138] || (_cache[138] = _createElementVNode("label", { class: "aviz-label" }, "Gestiune (opțional)", -1)),
                _createVNode(_unref(DxSelectBox), {
                  value: avizFormData.value.GestiuneId,
                  "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((avizFormData.value.GestiuneId) = $event)),
                  "data-source": _unref(dsGestiuni),
                  "display-expr": "Nume",
                  "value-expr": "Id",
                  "show-clear-button": true,
                  placeholder: "Se utilizează gestiunea implicită",
                  width: '100%'
                }, null, 8, ["value", "data-source"])
              ]),
              _createElementVNode("div", _hoisted_169, [
                _cache[139] || (_cache[139] = _createElementVNode("label", { class: "aviz-label" }, "Delegat", -1)),
                _createVNode(_unref(DxTextBox), {
                  value: avizFormData.value.ExpediereNume,
                  "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((avizFormData.value.ExpediereNume) = $event)),
                  placeholder: "Nume delegat",
                  width: '100%'
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_170, [
                _cache[140] || (_cache[140] = _createElementVNode("label", { class: "aviz-label" }, "Mijloc transport", -1)),
                _createVNode(_unref(DxTextBox), {
                  value: avizFormData.value.ExpediereMijloc,
                  "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((avizFormData.value.ExpediereMijloc) = $event)),
                  placeholder: "Nr. mașină / firmă transport",
                  width: '100%'
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_171, [
                _cache[141] || (_cache[141] = _createElementVNode("label", { class: "aviz-label" }, "Observații", -1)),
                _createVNode(_unref(DxTextBox), {
                  value: avizFormData.value.Observatii,
                  "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((avizFormData.value.Observatii) = $event)),
                  placeholder: "Observații aviz",
                  width: '100%'
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: isGenereazaAviz.value ? 'Se generează...' : 'Generează', type: 'default', disabled: isGenereazaAviz.value, onClick: onConfirmGenereazaAviz }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Anulează', stylingMode: 'outlined', disabled: isGenereazaAviz.value, onClick: () => showGenereazaAvizPopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(DxPopup), {
        visible: showDenumiriPopup.value,
        "show-title": false,
        "drag-enabled": true,
        "show-close-button": false,
        "close-on-outside-click": false,
        width: 920,
        height: 560,
        "wrapper-attr": { class: 'denumiri-popup' },
        onHidden: _cache[55] || (_cache[55] = ($event: any) => (showDenumiriPopup.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_172, [
            _createElementVNode("div", _hoisted_173, [
              _createElementVNode("div", _hoisted_174, [
                _cache[142] || (_cache[142] = _createElementVNode("i", { class: "dx-icon dx-icon-user ehp-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_175, [
                  _createElementVNode("span", _hoisted_176, "Denumire partener — " + _toDisplayString(denumiriProdusNume.value), 1),
                  _createElementVNode("span", _hoisted_177, "Partener: " + _toDisplayString(localOrderData.value?.Client?.Nume ?? '—'), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ehp-close",
                onClick: _cache[54] || (_cache[54] = ($event: any) => (showDenumiriPopup.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_178, [
              _createVNode(_unref(DxDataGrid), {
                ref_key: "denumiriGridRef",
                ref: denumiriGridRef,
                "data-source": denumiriRows.value,
                "key-expr": "ProdusID",
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": true,
                "row-alternation-enabled": true,
                "hover-state-enabled": true,
                "column-auto-width": false,
                height: "390"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxEditing), {
                    "allow-updating": true,
                    mode: "cell"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "PartenerNume",
                    caption: "Partener",
                    "allow-editing": false,
                    width: 160
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "ProdusNume",
                    caption: "Denumire internă",
                    "allow-editing": false
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "ProdusCod",
                    caption: "Cod intern",
                    "allow-editing": false,
                    width: 110
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "Cod",
                    caption: "Cod pt. partener",
                    width: 140
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "Nume",
                    caption: "Denumire pt. partener"
                  })
                ]),
                _: 1
              }, 8, ["data-source"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: isSavingDenumiri.value ? 'Se salvează...' : 'Salvează', type: 'default', disabled: isSavingDenumiri.value, onClick: onSaveDenumiri }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxToolbarItem), {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: { text: 'Închide', stylingMode: 'outlined', disabled: isSavingDenumiri.value, onClick: () => showDenumiriPopup.value = false }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (metaTooltip.value.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "meta-tooltip-popup",
            style: _normalizeStyle(metaTooltip.value.style)
          }, [
            _createElementVNode("span", _hoisted_179, _toDisplayString(metaTooltip.value.label), 1),
            _createElementVNode("p", _hoisted_180, _toDisplayString(metaTooltip.value.text), 1)
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})